import { themeColors } from '../utils/color-utils';

type ODSIcon = {
  viewBox: string;
  paths: React.ReactNode;
};

const ODSIcons = {
  approved: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 1C5.928 1 1 5.928 1 12s4.928 11 11 11 11-4.928 11-11S18.072 1 12 1zM5.5 12.882l4.469 4.469a.687.687 0 00.972 0L18.5 9.79a.687.687 0 000-.972l-.972-.972a.688.688 0 00-.973 0l-6.1 6.1-3.01-3.01a.687.687 0 00-.973 0l-.972.973a.688.688 0 000 .972z"
        clipRule="evenodd"
      />
    ),
  },

  important: {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M3.706 9.158l8-5.813a.5.5 0 01.589 0l8 5.813a.5.5 0 01.111.699l-1.435 1.974a.5.5 0 01-.698.111L12.295 7.6a.5.5 0 00-.588 0l-5.978 4.343a.5.5 0 01-.699-.11L3.596 9.856a.5.5 0 01.11-.699z"
        />
        <path
          fill="currentColor"
          d="M3.706 17.54l8-5.813a.5.5 0 01.589 0l8 5.813a.5.5 0 01.111.699l-1.435 1.974a.5.5 0 01-.698.111l-5.978-4.343a.5.5 0 00-.588 0l-5.978 4.343a.5.5 0 01-.699-.11l-1.434-1.975a.5.5 0 01.11-.699z"
        />
      </>
    ),
  },

  unclear: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 .5A1.5 1.5 0 00.5 2v18A1.5 1.5 0 002 21.5h18a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0020 .5H2zm7.256 7.776H7c.042-2.048 1.49-3.48 4.046-3.48C13.426 4.796 15 6.12 15 8.018c0 1.257-.608 2.131-1.781 2.822C12.11 11.48 12 11.847 12 12.663v.483H9.5v-.483c-.108-1.307.43-2.056 1.58-2.73 1.073-.641 1.398-1.05 1.398-1.84 0-.791-.633-1.365-1.582-1.365-.957 0-1.59.607-1.64 1.548zM9.5 14.75H12v2.5H9.5v-2.5z"
        clipRule="evenodd"
      />
    ),
  },

  challenged: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.881 2.768a1.009 1.009 0 00-1.762 0L1.143 20.163c-.402.702.09 1.587.882 1.587h19.95c.792 0 1.284-.885.882-1.587L12.88 2.768zM10.75 9h2.5v5.5h-2.5V9zm0 7.5h2.5V19h-2.5v-2.5z"
        clipRule="evenodd"
      />
    ),
  },

  radar: {
    viewBox: '0 0 28 28',
    paths: (
      <path
        fill="currentColor"
        d="M12.75 4.834A9.25 9.25 0 1023.25 14a9.217 9.217 0 00-2.71-6.54 1.25 1.25 0 011.768-1.768A11.717 11.717 0 0125.75 14c0 6.49-5.26 11.75-11.75 11.75S2.25 20.49 2.25 14 7.51 2.25 14 2.25c.69 0 1.25.56 1.25 1.25v8.629a2.25 2.25 0 11-2.5 0V9.416A4.752 4.752 0 0014 18.75a4.75 4.75 0 003.359-8.109 1.25 1.25 0 111.767-1.768 7.25 7.25 0 11-6.377-2.016V4.834z"
      />
    ),
  },

  'radar-with-track': {
    viewBox: '0 0 28 28',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M12.75 4.834A9.25 9.25 0 1 0 23.25 14a9.217 9.217 0 0 0-2.71-6.54 1.25 1.25 0 0 1 1.768-1.768A11.717 11.717 0 0 1 25.75 14c0 6.49-5.26 11.75-11.75 11.75S2.25 20.49 2.25 14 7.51 2.25 14 2.25c.69 0 1.25.56 1.25 1.25v8.629a2.25 2.25 0 1 1-2.5 0V9.416A4.752 4.752 0 0 0 14 18.75a4.75 4.75 0 0 0 3.359-8.109 1.25 1.25 0 1 1 1.767-1.768 7.25 7.25 0 1 1-6.377-2.016V4.834Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M15.25 9.417V6.858a7.22 7.22 0 0 1 3.877 2.015 1.25 1.25 0 0 0-1.797 1.739 4.727 4.727 0 0 0-2.08-1.195ZM18.31 12a4.742 4.742 0 0 0-.001 0h.001ZM13 2.292c.33-.028.663-.042 1-.042.69 0 1.25.56 1.25 1.25v1.334c.381.052.763.13 1.144.231a9.208 9.208 0 0 1 4.105 2.35 1.25 1.25 0 0 1 1.81-1.723 11.7 11.7 0 0 0-5.267-3.041A11.728 11.728 0 0 0 13 2.288v.003Zm12.46 9.104c.045.2.085.4.12.604h.001a11.758 11.758 0 0 0-.12-.604ZM21.301 8.32Z"
          clipRule="evenodd"
          opacity=".3"
        />
      </>
    ),
  },

  card: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V5a2 2 0 00-2-2H3zm.25 3a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h5.5A.25.25 0 009 7.75v-1.5A.25.25 0 008.75 6h-5.5zM3 10.25a.25.25 0 01.25-.25h17.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25H3.25a.25.25 0 01-.25-.25v-1.5zM3.25 14a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h15.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H3.25z"
        clipRule="evenodd"
      />
    ),
  },

  'card-slash': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M21.098 17.917c.554.425 1.083.829 1.586 1.208.357.282.423.801.109 1.128a.824.824 0 0 1-1.158.14L1.315 4.474a.825.825 0 1 1 1.02-1.298c.996.781 1.983 1.557 2.957 2.324h14.48c.955 0 1.728.728 1.728 1.625v9.75c0 .397-.151.76-.402 1.042Zm-2.396-1.855h.077c.12 0 .216-.09.216-.203v-1.218a.21.21 0 0 0-.216-.204h-2.155c.716.563 1.41 1.105 2.078 1.626Zm-4.144-3.25h4.999c.12 0 .216-.09.216-.203v-1.218c0-.113-.097-.204-.216-.204h-7.06l2.06 1.626ZM10.324 9.47a.194.194 0 0 0 .035-.11V8.14c0-.112-.097-.203-.216-.203h-1.76l1.941 1.533Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="m16.67 18.5-3.11-2.438H4.443c-.12 0-.216-.09-.216-.203v-1.218c0-.113.097-.204.216-.204h7.042l-2.074-1.624H4.443a.21.21 0 0 1-.216-.204v-1.218c0-.113.097-.204.216-.204h2.894L5.263 9.563h-.82a.21.21 0 0 1-.216-.204v-.608L2.5 7.398v9.477c0 .898.773 1.625 1.727 1.625h12.444Z"
        />
      </>
    ),
  },

  'card-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M2.818 4C1.814 4 1 4.784 1 5.75v10.5c0 .966.814 1.75 1.818 1.75h6.316a5.33 5.33 0 0 1 .062-2.625h-6.15a.223.223 0 0 1-.228-.219v-1.312c0-.121.102-.219.227-.219h7.015a5.325 5.325 0 0 1 2.286-1.75h-9.3a.223.223 0 0 1-.228-.219v-1.312c0-.121.102-.219.227-.219h15.91c.125 0 .227.098.227.219V11.5h.425c.482 0 .949.064 1.393.185V5.75C21 4.784 20.186 4 19.182 4H2.818Zm.227 2.625a.223.223 0 0 0-.227.219v1.312c0 .121.102.219.227.219h5a.223.223 0 0 0 .228-.219V6.844a.223.223 0 0 0-.228-.219h-5Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M11 16.81a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31A3.31 3.31 0 0 1 11 16.81Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M18.944 16.148h-3.972a.661.661 0 1 0 0 1.324h3.972a.661.661 0 1 0 0-1.324Z"
        />
      </>
    ),
  },

  'card-stencil': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M8.5 2.25A.25.25 0 008.25 2H2.5a2 2 0 00-2 2v4.25c0 .138.112.25.25.25h1.5a.25.25 0 00.25-.25V4.5A.5.5 0 013 4h5.25a.25.25 0 00.25-.25v-1.5zM14.5 3.75c0 .138.112.25.25.25H21a.5.5 0 01.5.5v3.75c0 .138.112.25.25.25h1.5a.25.25 0 00.25-.25V4a2 2 0 00-2-2h-6.75a.25.25 0 00-.25.25v1.5zM21.5 13.75a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25V18a2 2 0 01-2 2h-6.75a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25H21a.5.5 0 00.5-.5v-3.75zM8.25 20a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H3a.5.5 0 01-.5-.5v-3.75a.25.25 0 00-.25-.25H.75a.25.25 0 00-.25.25V18a2 2 0 002 2h5.75zM18 15.25a.25.25 0 01-.25.25H5.25a.25.25 0 01-.25-.25v-1.5a.25.25 0 01.25-.25h12.5a.25.25 0 01.25.25v1.5zM5.25 6.5a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-5.5zM5 10.25a.25.25 0 01.25-.25h13.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25H5.25a.25.25 0 01-.25-.25v-1.5z"
      />
    ),
  },

  'bring-front': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.623 8.082a1.25 1.25 0 010-2.164L11.375.86a1.25 1.25 0 011.25 0l8.752 5.057a1.25 1.25 0 010 2.164l-2.388 1.38 2.388 1.422c.833.496.833 1.736 0 2.232L19.052 14.5l2.325 1.384c.833.496.833 1.735 0 2.232l-8.752 5.211c-.386.23-.863.23-1.25 0l-8.752-5.212c-.833-.495-.833-1.735 0-2.23L4.948 14.5l-2.325-1.384c-.833-.496-.833-1.736 0-2.232l2.389-1.422-2.389-1.38zm4.324 7.608L4.747 17 12 21.319l7.252-4.32-2.199-1.309-4.428 2.637c-.386.23-.863.23-1.25 0L6.947 15.69zm4.428-2.551L7.04 10.635 4.748 12 12 16.319 19.252 12l-2.293-1.366-4.334 2.505a1.25 1.25 0 01-1.25 0z"
        clipRule="evenodd"
      />
    ),
  },

  'bring-forward': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.623 8.418a1.25 1.25 0 000 2.164l2.389 1.38-2.389 1.422c-.833.496-.833 1.736 0 2.232l8.752 5.211c.387.23.864.23 1.25 0l8.752-5.212c.833-.495.833-1.735 0-2.23l-2.388-1.423 2.388-1.38a1.25 1.25 0 000-2.164L12.625 3.36a1.25 1.25 0 00-1.25 0L2.623 8.418zm4.418 4.717l4.334 2.504a1.25 1.25 0 001.25 0l4.334-2.505 2.293 1.366L12 18.819 4.748 14.5l2.293-1.365z"
        clipRule="evenodd"
      />
    ),
  },

  'send-back': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.623 5.884c-.833.496-.833 1.736 0 2.232L4.948 9.5l-2.325 1.384c-.833.496-.833 1.736 0 2.232L4.948 14.5l-2.325 1.384c-.833.496-.833 1.735 0 2.232l8.752 5.211c.387.23.864.23 1.25 0l8.752-5.212c.833-.495.833-1.735 0-2.23L19.052 14.5l2.325-1.384c.833-.496.833-1.736 0-2.232L19.052 9.5l2.325-1.384c.833-.496.833-1.736 0-2.232L12.625.673a1.218 1.218 0 00-1.25 0L2.623 5.884zM4.748 7L12 11.319 19.252 7 12 2.681 4.748 7zm0 5l2.199-1.31 4.428 2.637c.387.23.864.23 1.25 0l4.428-2.637 2.2 1.31L12 16.319 4.748 12z"
        clipRule="evenodd"
      />
    ),
  },

  'send-backward': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.623 10.616c-.833-.496-.833-1.736 0-2.232l8.752-5.211c.387-.23.864-.23 1.25 0l8.752 5.211c.833.496.833 1.736 0 2.232L19.052 12l2.325 1.384c.833.496.833 1.736 0 2.232l-8.752 5.211c-.386.23-.863.23-1.25 0l-8.752-5.212c-.833-.495-.833-1.735 0-2.23L4.948 12l-2.325-1.384zM12 13.819L4.748 9.5 12 5.181 19.252 9.5 12 13.819z"
        clipRule="evenodd"
      />
    ),
  },

  orders: {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M7 12.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3 3.25A2.25 2.25 0 0 1 5.25 1h7.818c.597 0 1.17.237 1.591.659l5.682 5.682c.422.422.659.994.659 1.591V20.75A2.25 2.25 0 0 1 18.75 23H5.25A2.25 2.25 0 0 1 3 20.75V3.25ZM18.75 21H5.25a.25.25 0 0 1-.25-.25V3.25A.25.25 0 0 1 5.25 3H13v5.25c0 .414.336.75.75.75H19v11.75a.25.25 0 0 1-.25.25Z"
          clipRule="evenodd"
        />
      </>
    ),
  },

  'draw-line': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.501 13.375H7.488A2.737 2.737 0 015.12 14.75a2.75 2.75 0 110-5.5c.897 0 1.687.435 2.187 1.101.066.087.127.179.182.274h9.013c.015-.027.032-.054.048-.08a2.735 2.735 0 012.32-1.295 2.75 2.75 0 110 5.5 2.726 2.726 0 01-2.187-1.101 2.742 2.742 0 01-.182-.274zM19.557 12a.688.688 0 01-1.374 0v-.004a.688.688 0 011.375.004zM5.13 11.313a.688.688 0 01-.009 1.374.688.688 0 01-.688-.687v-.004a.688.688 0 01.697-.683z"
        clipRule="evenodd"
      />
    ),
  },

  marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.346 17.177A8.28 8.28 0 0023 12.19C23 7.667 19.418 4 15 4s-8 3.667-8 8.19a8.28 8.28 0 001.647 4.978L15.039 26l6.307-8.823zm-6.287 1.49c3.461 0 6.268-2.873 6.268-6.417 0-3.544-2.807-6.417-6.268-6.417-3.462 0-6.268 2.873-6.268 6.417 0 3.544 2.806 6.417 6.268 6.417z"
        clipRule="evenodd"
      />
    ),
  },

  star_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M15 4L17.5967 12.4033H26L19.2016 17.5967L21.7984 26L15 20.8065L8.20163 26L10.7984 17.5967L4 12.4033H12.4033L15 4Z"
        fill="currentColor"
      />
    ),
  },

  circle_marker: {
    viewBox: '0 0 30 30',
    paths: <circle cx="15" cy="15" r="7" fill="currentColor" />,
  },

  circle_minus_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M15 24.625C20.3163 24.625 24.625 20.3163 24.625 15C24.625 9.68369 20.3163 5.375 15 5.375C9.68369 5.375 5.375 9.68369 5.375 15C5.375 20.3163 9.68369 24.625 15 24.625ZM12.293 14.0977H17.707C18.2071 14.0977 18.6094 14.5 18.6094 15C18.6094 15.5 18.2071 15.9023 17.707 15.9023H12.293C11.7929 15.9023 11.3906 15.5 11.3906 15C11.3906 14.5 11.7929 14.0977 12.293 14.0977Z"
        fill="currentColor"
      />
    ),
  },

  dot_marker: {
    viewBox: '0 0 30 30',
    paths: <circle cx="15" cy="15" r="3" fill="currentColor" />,
  },

  exclamation_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M16.2031 6.57812C16.2031 5.91265 15.6655 5.375 15 5.375C14.3345 5.375 13.7969 5.91265 13.7969 6.57812V18.6094C13.7969 19.2749 14.3345 19.8125 15 19.8125C15.6655 19.8125 16.2031 19.2749 16.2031 18.6094V6.57812ZM15 24.625C15.8309 24.625 16.5039 23.952 16.5039 23.1211C16.5039 22.2902 15.8309 21.6172 15 21.6172C14.1691 21.6172 13.4961 22.2902 13.4961 23.1211C13.4961 23.952 14.1691 24.625 15 24.625Z"
        fill="currentColor"
      />
    ),
  },

  times_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M21.3493 10.3493C21.8864 9.81221 21.8864 8.93994 21.3493 8.40283C20.8122 7.86572 19.9399 7.86572 19.4028 8.40283L14.8782 12.9317L10.3493 8.40713C9.81221 7.87002 8.93994 7.87002 8.40283 8.40713C7.86572 8.94424 7.86572 9.8165 8.40283 10.3536L12.9317 14.8782L8.40713 19.4071C7.87002 19.9442 7.87002 20.8165 8.40713 21.3536C8.94424 21.8907 9.8165 21.8907 10.3536 21.3536L14.8782 16.8247L19.4071 21.3493C19.9442 21.8864 20.8165 21.8864 21.3536 21.3493C21.8907 20.8122 21.8907 19.9399 21.3536 19.4028L16.8247 14.8782L21.3493 10.3493Z"
        fill="currentColor"
      />
    ),
  },

  triangle_marker: {
    viewBox: '0 0 30 30',
    paths: <path d="M15 6L25 24H5L15 6Z" fill="currentColor" />,
  },

  triangle_exclamation_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M25.7536 21.543L16.5884 5.90234C15.8867 4.69922 14.1159 4.69922 13.4095 5.90234L4.24859 21.543C3.54347 22.7418 4.42171 24.25 5.835 24.25H24.1655C25.5731 24.25 26.454 22.7461 25.7536 21.543ZM13.9673 10.8438C13.9673 10.2744 14.4292 9.8125 14.9985 9.8125C15.5679 9.8125 16.0298 10.2766 16.0298 10.8438V16.3438C16.0298 16.9131 15.5679 17.375 15.0372 17.375C14.5065 17.375 13.9673 16.9152 13.9673 16.3438V10.8438ZM14.9985 21.5C14.2526 21.5 13.6476 20.895 13.6476 20.1491C13.6476 19.4031 14.2521 18.7981 14.9985 18.7981C15.7449 18.7981 16.3495 19.4031 16.3495 20.1491C16.3477 20.8941 15.7462 21.5 14.9985 21.5Z"
        fill="currentColor"
      />
    ),
  },

  inverted_triangle_marker: {
    viewBox: '0 0 30 30',
    paths: <path d="M15 24 5 6h20L15 24Z" fill="currentColor" />,
  },

  diamond_marker: {
    viewBox: '0 0 30 30',
    paths: <path d="m15 3 10 12-10 12L5 15 15 3Z" fill="currentColor" />,
  },

  square_marker: {
    viewBox: '0 0 30 30',
    paths: <rect x="5" y="5" width="20" height="20" fill="currentColor" />,
  },

  square_check_marker: {
    viewBox: '0 0 30 30',
    paths: (
      <path
        d="M8.125 5.375C6.6082 5.375 5.375 6.6082 5.375 8.125V21.875C5.375 23.3918 6.6082 24.625 8.125 24.625H21.875C23.3918 24.625 24.625 23.3918 24.625 21.875V8.125C24.625 6.6082 23.3918 5.375 21.875 5.375H8.125ZM18.6266 13.1395L15.1891 18.6395C15.0086 18.9273 14.6992 19.1078 14.3598 19.125C14.0203 19.1422 13.6937 18.9875 13.4918 18.7125L11.4293 15.9625C11.0855 15.507 11.1801 14.8625 11.6355 14.5187C12.091 14.175 12.7355 14.2695 13.0793 14.725L14.2395 16.2719L16.8777 12.048C17.1785 11.5668 17.8145 11.4164 18.3 11.7215C18.7855 12.0266 18.9316 12.6582 18.6266 13.1437V13.1395Z"
        fill="currentColor"
      />
    ),
  },

  'empty-symbol': {
    viewBox: '21 46 158 108',
    paths: (
      <path
        d="M25,50 l150,0 0,100 -150,0 z"
        strokeWidth="4"
        strokeDasharray="24,24"
        stroke="currentColor"
        fill="none"
      />
    ),
  },

  'mil-symbol': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 20V4h22v16H1zM18.045 6.4H3.4v10.042L18.045 6.4zM5.955 17.6H20.6V7.558L5.955 17.6z"
        clipRule="evenodd"
      />
    ),
  },

  'atom-engine': {
    viewBox: '0 0 30 32',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M7.14091 13.3555L1.76415 17.4301C0.781758 18.1981 0.961335 19.7555 2.09162 20.2568L17.1444 26.7741H17.1656L7.14091 13.3555Z"
        />
        <path
          fill="currentColor"
          d="M26.8945 12.7793H26.9156L28.8593 29.2273C29.0072 30.4753 27.7501 31.4033 26.6198 30.9126L20.4297 28.2353L26.8839 12.79L26.8945 12.7793Z"
        />
        <path
          fill="currentColor"
          d="M10.0035 11.2432V11.2219L23.1126 1.28057C24.1056 0.533903 25.5317 1.15257 25.669 2.3899L26.4718 9.1419L9.99292 11.2432H10.0035Z"
        />
      </>
    ),
  },

  'dynamic-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8647 1L23 12L11.8647 23V17.2415H1V14.7456H14.3914V16.9742L19.4267 12L14.3914 7.0258V9.25443H1V6.75847H11.8647V1Z"
      />
    ),
  },

  clip: {
    viewBox: '0 0 448 512',
    paths: (
      <path
        fill="currentColor"
        d="M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
      />
    ),
  },

  'comment-lines-light': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M8.227 17.539a2.053 2.053 0 0 0-1.916.275c-.352.258-.958.636-1.693.975.24-.632.425-1.345.486-2.123a2.086 2.086 0 0 0-.508-1.525c-1-1.13-1.534-2.454-1.534-3.829 0-3.416 3.58-6.874 8.938-6.874 5.358 0 8.938 3.458 8.938 6.875 0 3.415-3.58 6.874-8.938 6.874-1.358 0-2.634-.236-3.773-.648ZM2.13 19.21a7.757 7.757 0 0 1-.22.348l-.012.022-.206.296c-.15.202-.314.4-.486.58a.688.688 0 0 0 .49 1.173c.22 0 .438-.013.658-.034l.03-.004c.189-.022.378-.048.567-.082.034-.004.069-.013.103-.021.765-.15 1.5-.409 2.153-.692.984-.43 1.822-.941 2.333-1.315 1.366.494 2.879.769 4.473.769 6.076 0 11-4 11-8.938 0-4.937-4.937-8.937-11.013-8.937s-11 4-11 8.938c0 1.937.76 3.73 2.05 5.194-.082 1.053-.49 1.99-.92 2.703ZM7.531 8.562A1.03 1.03 0 0 0 6.5 9.594c0 .571.46 1.031 1.031 1.031h8.938c.571 0 1.031-.46 1.031-1.031 0-.572-.46-1.031-1.031-1.031H7.53Zm0 4.126c-.571 0-1.031.46-1.031 1.03 0 .572.46 1.032 1.031 1.032h4.813c.571 0 1.031-.46 1.031-1.031 0-.572-.46-1.031-1.031-1.031H7.53Z"
      />
    ),
  },

  'comment-v2': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14 4h-4a6 6 0 0 0-6 6v10h10a6 6 0 0 0 6-6v-4a6 6 0 0 0-6-6Zm-4-3a9 9 0 0 0-9 9v13h13a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9h-4Z"
        clipRule="evenodd"
      />
    ),
  },
  'comment-v2-add': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M14 4h-4a6 6 0 0 0-6 6v10h10a6 6 0 0 0 6-6v-4a6 6 0 0 0-6-6Zm-4-3a9 9 0 0 0-9 9v13h13a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9h-4Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M13.072 13.072h3.214c.394 0 .714-.32.714-.715v-.714a.714.714 0 0 0-.714-.715H13.07V7.714A.714.714 0 0 0 12.357 7h-.714a.714.714 0 0 0-.715.714v3.214H7.714a.714.714 0 0 0-.714.715v.714c0 .395.32.715.714.715h3.214v3.214c0 .394.32.714.715.714h.714c.395 0 .714-.32.715-.714V13.07Z"
        />
      </>
    ),
  },

  'add-row': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M20 13V5.25C20 4.56 19.44 4 18.75 4H2.25C1.56 4 1 4.56 1 5.25v12.5c0 .69.56 1.25 1.25 1.25H12v-3H4v-3h16Zm-3-3V7H4v3h13Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M20 16.25c0-.69-.56-1.25-1.25-1.25h-.5c-.69 0-1.25.56-1.25 1.25V18h-1.75c-.69 0-1.25.56-1.25 1.25v.5c0 .69.56 1.25 1.25 1.25H17v1.75c0 .69.56 1.25 1.25 1.25h.5c.69 0 1.25-.56 1.25-1.25V21h1.75c.69 0 1.25-.56 1.25-1.25v-.5c0-.69-.56-1.25-1.25-1.25H20v-1.75Z"
        />
      </>
    ),
  },

  'add-column': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M11 21H3.25C2.56 21 2 20.44 2 19.75V3.25C2 2.56 2.56 2 3.25 2h12.5c.69 0 1.25.56 1.25 1.25V13h-3V5h-3v16Zm-3-3H5V5h3v13Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M14.25 21c-.69 0-1.25-.56-1.25-1.25v-.5c0-.69.56-1.25 1.25-1.25H16v-1.75c0-.69.56-1.25 1.25-1.25h.5c.69 0 1.25.56 1.25 1.25V18h1.75c.69 0 1.25.56 1.25 1.25v.5c0 .69-.56 1.25-1.25 1.25H19v1.75c0 .69-.56 1.25-1.25 1.25h-.5c-.69 0-1.25-.56-1.25-1.25V21h-1.75Z"
        />
      </>
    ),
  },

  'merge-cells': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.5 22.5h19a1 1 0 0 0 1-1v-19a1 1 0 0 0-1-1h-19a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1Zm2-18v3h6v-3h-6Zm0 9v-3h15v3h-15Zm0 3v3h6v-3h-6Zm9 0v3h6v-3h-6Zm6-9h-6v-3h6v3Z"
        clipRule="evenodd"
      />
    ),
  },

  'merge-cards': {
    viewBox: '0 0 12 10',
    paths: (
      <path
        fill="#5B687B"
        d="M1.1875 0.875C0.807227 0.875 0.5 1.18223 0.5 1.5625C0.5 1.94277 0.807227 2.25 1.1875 2.25H3.27578C3.48418 2.25 3.68184 2.34453 3.81289 2.50781L5.80664 5L3.81289 7.49219C3.68184 7.65547 3.48418 7.75 3.27578 7.75H1.1875C0.807227 7.75 0.5 8.05723 0.5 8.4375C0.5 8.81777 0.807227 9.125 1.1875 9.125H3.27578C3.90313 9.125 4.49395 8.83926 4.88711 8.35156L7.01836 5.6875H8.75V6.375C8.75 6.65215 8.91758 6.90352 9.17539 7.01094C9.4332 7.11836 9.72754 7.0582 9.9252 6.8627L11.3002 5.4877C11.4291 5.35879 11.5021 5.18477 11.5021 5.00215C11.5021 4.81953 11.4291 4.64551 11.3002 4.5166L9.9252 3.1416C9.72754 2.94395 9.4332 2.88594 9.17539 2.99336C8.91758 3.10078 8.75 3.35 8.75 3.6293V4.3168H7.01836L4.88711 1.64844C4.49609 1.15859 3.90313 0.875 3.27578 0.875H1.1875Z"
      />
    ),
  },

  'delete-column': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3.164 20.957a1 1 0 0 1 0-1.414L18.721 3.987a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-4.385 4.385V21a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1.507l-2.171 2.171a1 1 0 0 1-1.414 0l-.708-.707Zm7.293-4.464 3-3V19h-3v-2.507Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M7.457 3v9.97l3-3V5h3v1.97l3-3V3a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1Z"
        />
      </>
    ),
  },

  'delete-row': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M20.957 3.707a1 1 0 0 0-1.414 0L3.987 19.263a1 1 0 0 0 0 1.415l.707.707a1 1 0 0 0 1.414 0L10.493 17H21a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-1.507l2.171-2.172a1 1 0 0 0 0-1.414l-.707-.707ZM16.493 11l-3 3H19v-3h-2.507Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M3 8h9.97l-3 3H5v3h1.97l-3 3H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"
        />
      </>
    ),
  },
  distribute: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M7.5 23 3 18.6l4.5-4.4 1.603 1.54-1.8 1.76h9.394l-1.772-1.76L16.5 14.2l4.5 4.4-4.5 4.4-1.603-1.54 1.8-1.76H7.303l1.772 1.76L7.5 23ZM4.125 12V1h2.25v11h-2.25Zm6.75 0V1h2.25v11h-2.25Zm6.75 0V1h2.25v11h-2.25Z"
      />
    ),
  },
  'split-cells': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.5 22.5h-19a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1Zm-17-15v-3h6v3h-6Zm0 3v3H6v-3H4.5Zm4.5 0h1.5v3H9v-3Zm9 0h1.5v3H18v-3Zm-3 0h-1.5v3H15v-3Zm-10.5 9v-3h6v3h-6Zm9 0v-3h6v3h-6Zm0-12h6v-3h-6v3Z"
        clipRule="evenodd"
      />
    ),
  },

  'add-list': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.188 3h14.624c.932 0 1.688.768 1.688 1.714V12h-2.25V7.571h-5.625v9.143h.875V19H3.187c-.931 0-1.687-.767-1.687-1.714V4.714C1.5 3.767 2.256 3 3.188 3Zm.562 13.714h5.625V7.571H3.75v9.143Zm18.244 2.28L19.5 19l-.006 2.494c0 .28-.227.506-.506.506H18a.506.506 0 0 1-.506-.506L17.5 19l-2.494-.006a.506.506 0 0 1-.506-.506V17.5c0-.28.227-.506.506-.506L17.5 17l-.006-2.494c0-.28.227-.506.506-.506h.988c.28 0 .506.227.506.506L19.5 17l2.494-.006c.28 0 .506.227.506.506v.988c0 .28-.227.506-.506.506Z"
        clipRule="evenodd"
      />
    ),
  },

  paste: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M14.75 5.125v-.688a2.063 2.063 0 0 0-2.063-2.062h-2.431A2.755 2.755 0 0 0 7.874 1a2.755 2.755 0 0 0-2.38 1.375H3.062A2.062 2.062 0 0 0 1 4.438v13.75c0 1.138.923 2.062 2.063 2.062H9.25V8.562a3.436 3.436 0 0 1 3.438-3.437h2.062Zm-6.875-.344A1.033 1.033 0 0 1 6.844 3.75a1.032 1.032 0 1 1 1.031 1.031Zm11 1.719v4.125H23L18.875 6.5ZM17.5 10.625V6.5h-4.813a2.063 2.063 0 0 0-2.062 2.063v12.374c0 1.14.923 2.063 2.063 2.063h8.25A2.063 2.063 0 0 0 23 20.937V12h-4.125a1.38 1.38 0 0 1-1.375-1.375Z"
      />
    ),
  },

  copy: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M17.5 5.125V1h-4.813a2.062 2.062 0 0 0-2.062 2.063v12.374c0 1.14.923 2.063 2.063 2.063h8.25A2.062 2.062 0 0 0 23 15.437V6.5h-4.086c-.795 0-1.414-.619-1.414-1.375ZM18.875 1v4.125H23L18.875 1ZM9.25 16.125V6.5H3.062A2.062 2.062 0 0 0 1 8.563v12.374C1 22.078 1.923 23 3.063 23h8.25a2.062 2.062 0 0 0 2.062-2.063v-2.062H12a2.753 2.753 0 0 1-2.75-2.75Z"
      />
    ),
  },

  board: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m20.5 3-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5ZM15 19l-6-2.11V5l6 2.11V19Z"
      />
    ),
  },

  'add-card': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fillRule="evenodd"
          fill="currentColor"
          d="M2.727 4C1.773 4 1 4.728 1 5.625v9.75C1 16.273 1.773 17 2.727 17H13v-2.438H2.943c-.12 0-.216-.09-.216-.203v-1.218c0-.113.097-.204.216-.204H16v-1.624H2.943a.21.21 0 0 1-.216-.204V9.891c0-.113.097-.204.216-.204h15.114a.21.21 0 0 1 .216.204V11H20V5.625C20 4.728 19.227 4 18.273 4H2.727Zm.216 2.438c-.12 0-.216.09-.216.203v1.218c0 .113.097.204.216.204h4.75a.21.21 0 0 0 .216-.204V6.641c0-.113-.097-.204-.216-.204h-4.75Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="m20 18 2.494-.006c.28 0 .506-.227.506-.506V16.5a.506.506 0 0 0-.506-.506L20 16l-.006-2.494a.506.506 0 0 0-.506-.506H18.5a.506.506 0 0 0-.506.506L18 16l-2.494-.006A.506.506 0 0 0 15 16.5v.988c0 .28.227.506.506.506L18 18l-.006 2.494c0 .28.227.506.506.506h.988c.28 0 .506-.227.506-.506L20 18Z"
        />
      </>
    ),
  },

  metric: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M6.155 13.744 4.802 15.23V19H2.323V6.203h2.479v5.862l1.16-1.564 3.111-4.298h3.024l-4.307 5.66L12.255 19H9.319l-3.164-5.256Zm10.029-7.541 1.212 4.808 1.38-4.808h3.068V19h-2.268v-3.788l.106-5.985-1.68 5.554h-1.22l-1.504-5.317.106 5.748V19h-2.268V6.203h3.068Z"
      />
    ),
  },

  imperial: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m5.373 6.203 1.213 4.808 1.38-4.808h3.067V19H8.766v-3.788l.105-5.985-1.679 5.554H5.971L4.468 9.464l.105 5.748V19H2.306V6.203h3.067Zm8.323 0h7.4v1.995h-2.495v8.816h2.496V19h-7.4v-1.986h2.434V8.198h-2.435V6.203Z"
      />
    ),
  },

  nautical: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M10.778 19h-2.46l-3.56-8.253V19H2.27V6.203h2.487l3.533 8.218.009-8.218h2.478V19Zm5.406-12.797 1.212 4.808 1.38-4.808h3.068V19h-2.268v-3.788l.106-5.985-1.68 5.554h-1.22l-1.504-5.317.106 5.748V19h-2.268V6.203h3.068Z"
      />
    ),
  },

  'box-solid': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M20 4H4v16h16V4ZM1.333 1.333v21.334h21.334V1.333H1.333Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'box-solid-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.333 22.667V1.333h21.334v21.334H1.333Zm1.334-20h18.666v18.666H2.667V2.667Z"
        clipRule="evenodd"
      />
    ),
  },

  'box-solid-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 5H5v14h14V5ZM1.333 1.333v21.334h21.334V1.333H1.333Z"
        clipRule="evenodd"
      />
    ),
  },

  'box-dashed': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M6.667 1.333H1.333v5.334H4V4h2.667V1.333Zm0 21.334V20H4v-2.667H1.333v5.334h5.334ZM9.333 1.333h5.334V4H9.333V1.333ZM14.667 20H9.333v2.667h5.334V20Zm2.666-18.667h5.334v5.334H20V4h-2.667V1.333Zm0 21.334h5.334v-5.334H20V20h-2.667v2.667ZM4 14.667V9.333H1.333v5.334H4Zm18.667-5.334v5.334H20V9.333h2.667Z"
        fill="currentColor"
      />
    ),
  },

  'box-dashed-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M6.667 1.333H1.333v5.334H3V3h3.667V1.333Zm0 21.334V21H3v-3.667H1.333v5.334h5.334ZM9.333 1.333h5.334V3H9.333V1.333ZM14.667 21H9.333v1.667h5.334V21Zm2.666-19.667h5.334v5.334H21V3h-3.667V1.333Zm0 21.334h5.334v-5.334H21V21h-3.667v1.667ZM3 14.667V9.333H1.333v5.334H3Zm19.667-5.334v5.334H21V9.333h1.667Z"
      />
    ),
  },

  'box-dashed-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M6.667 1.333H1.333v5.334H5V5h1.667V1.333Zm0 21.334V19H5v-1.667H1.333v5.334h5.334ZM9.333 1.333h5.334V5H9.333V1.333ZM14.667 19H9.333v3.667h5.334V19Zm2.666-17.667h5.334v5.334H19V5h-1.667V1.333Zm0 21.334h5.334v-5.334H19V19h-1.667v3.667ZM5 14.667V9.333H1.333v5.334H5Zm17.667-5.334v5.334H19V9.333h3.667Z"
      />
    ),
  },

  'box-dotted': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M4.5 4.5v-3h-3v3h3Zm6-3h-3v3h3v-3Zm6 0h-3v3h3v-3Zm3 0h3v3h-3v-3Zm-9 18h-3v3h3v-3Zm3 0h3v3h-3v-3Zm-9-12v3h-3v-3h3Zm0 15v-3h-3v3h3Zm0-9v3h-3v-3h3Zm18-3v-3h-3v3h3Zm0 3v3h-3v-3h3Zm0 9v-3h-3v3h3Z"
        fill="currentColor"
      />
    ),
  },

  'box-dotted-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 1H1v2h2V1Zm0 5H1v2h2V6Zm18 0h2v2h-2V6ZM3 11H1v2h2v-2Zm18 0h2v2h-2v-2ZM3 16H1v2h2v-2Zm18 0h2v2h-2v-2ZM3 21H1v2h2v-2ZM6 1h2v2H6V1Zm2 20H6v2h2v-2Zm3-20h2v2h-2V1Zm2 20h-2v2h2v-2Zm3-20h2v2h-2V1Zm2 20h-2v2h2v-2Zm3-20h2v2h-2V1Zm2 20h-2v2h2v-2Z"
        clipRule="evenodd"
      />
    ),
  },

  'box-dotted-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M1 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM1 21a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm0-6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm18 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM1 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm18 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM7 21a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
      />
    ),
  },

  'box-double': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fillRule="evenodd"
          d="M4 20V4h16v16H4ZM5.333 5.333h13.334v13.334H5.333V5.333Z"
          clipRule="evenodd"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          d="M1.333 22.667V1.333h21.334v21.334H1.333Zm1.334-20h18.666v18.666H2.667V2.667Z"
          clipRule="evenodd"
          fill="currentColor"
        />
      </>
    ),
  },

  'box-double-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3 21V3h18v18H3ZM4 4h16v16H4V4Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M1 23V1h22v22H1ZM2 2h20v20H2V2Z"
          clipRule="evenodd"
        />
      </>
    ),
  },

  'box-double-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 3h18v18H3V3ZM1 23V1h22v22H1ZM6 6h12v12H6V6ZM4 20V4h16v16H4Z"
        clipRule="evenodd"
      />
    ),
  },

  'box-mixed-normal': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fillRule="evenodd"
          d="M2.454 1.04 1.04 2.454 21.546 22.96l1.414-1.414-1.96-1.96V3H4.414l-1.96-1.96ZM6.414 5 19 17.586V5H6.414Z"
          clipRule="evenodd"
          fill="currentColor"
        />
        <path d="M3 21V7.414l2 2V19h9.586l2 2H3Z" fill="currentColor" />
      </>
    ),
  },

  'line-dashed-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M9 16.763 3 12l6-4.763V10.5h4.25v3H9v3.263ZM22 13.5v-3h-5.25v3H22Z"
        fill="currentColor"
      />
    ),
  },

  'line-dashed-thin-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="m3 12 6 4.763V12.75h4.05v-1.5H9V7.237L3 12Zm13.63.75H22v-1.5h-5.37v1.5Z"
        fill="currentColor"
      />
    ),
  },

  'line-dashed-thick-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="m3 12 6 4.763V14h4.219v-4H9V7.237L3 12Zm13.731 2H22v-4h-5.269v4Z"
        fill="currentColor"
      />
    ),
  },

  'line-dashed': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M3 10.5v3h6.75v-3H3Zm18 3h-6.75v-3H21v3Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'line-dashed-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M3 10v4h6.75v-4H3Zm18 4h-6.75v-4H21v4Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'line-dashed-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M3 11.25v1.5h6.75v-1.5H3Zm18 1.5h-6.75v-1.5H21v1.5Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'line-dotted-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M9 16.763 3 12l6-4.763V10.5h1v3H9v3.263ZM22 13.5v-3h-3v3h3Zm-6 0h-3v-3h3v3Z"
        fill="currentColor"
      />
    ),
  },

  'line-dotted-thin-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="m3 12 6 4.763V12.75h.25v-1.5H9V7.237L3 12Zm9.25-.75v1.5h-1.5v-1.5h1.5Zm1.5 0v1.5h1.5v-1.5h-1.5Zm3 1.5h1.5v-1.5h-1.5v1.5Zm4.5 0v-1.5h-1.5v1.5h1.5Z"
        fill="currentColor"
      />
    ),
  },

  'line-dotted-thick-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="m3 12 6 4.763v-2.94h.43v-3.647H9v-2.94L3 12Zm9.823 1.824h3.392v-3.648h-3.392v3.648ZM23 10.176v3.648h-3.392v-3.648H23Z"
        fill="currentColor"
      />
    ),
  },

  'line-dotted': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M4.5 10.5v3h3v-3h-3Zm9 3h-3v-3h3v3Zm6 0v-3h-3v3h3Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'line-dotted-thick': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fillRule="evenodd"
        d="M2 10v4h4v-4H2Zm12 4h-4v-4h4v4Zm8 0v-4h-4v4h4Z"
        clipRule="evenodd"
        fill="currentColor"
      />
    ),
  },

  'line-dotted-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M3.75 12.75v-1.5h1.5v1.5h-1.5Zm3 0h1.5v-1.5h-1.5v1.5Zm4.5-1.5v1.5h-1.5v-1.5h1.5Zm1.5 1.5v-1.5h1.5v1.5h-1.5Zm3 0h1.5v-1.5h-1.5v1.5Zm4.5-1.5v1.5h-1.5v-1.5h1.5Z"
        fill="currentColor"
      />
    ),
  },

  'line-double-arrow': {
    viewBox: '0 0 24 24',
    paths: <path d="M9 16.763 3 12l6-4.763V9h13v2H9v2h13v2H9v1.763Z" fill="currentColor" />,
  },

  'line-double-thin-arrow': {
    viewBox: '0 0 24 24',
    paths: <path d="m3 12 6 4.763V13.5h13v-1H9v-1h13v-1H9V7.237L3 12Z" fill="currentColor" />,
  },

  'line-double-thick-arrow': {
    viewBox: '0 0 24 24',
    paths: (
      <path d="m3 12 6 4.763V15.5h13v-2.333H9v-2.334h13V8.5H9V7.237L3 12Z" fill="currentColor" />
    ),
  },

  'line-double': {
    viewBox: '0 0 24 24',
    paths: <path d="M3 11V9h18v2H3Zm0 4v-2h18v2H3Z" fill="currentColor" />,
  },

  'line-double-thick': {
    viewBox: '0 0 24 24',
    paths: <path d="M3 10.667V8h18v2.667H3ZM3 16v-2.667h18V16H3Z" fill="currentColor" />,
  },

  'line-double-thin': {
    viewBox: '0 0 24 24',
    paths: <path d="M3 11.5v-1h18v1H3Zm0 2v-1h18v1H3Z" fill="currentColor" />,
  },

  'line-regular': {
    viewBox: '0 0 24 24',
    paths: (
      <path fillRule="evenodd" d="M3 10.75v2.5h18v-2.5H3Z" clipRule="evenodd" fill="currentColor" />
    ),
  },

  'line-solid-arrow': {
    viewBox: '0 0 24 24',
    paths: <path d="M9 16.763 3 12l6-4.763V10.5h13v3H9v3.263Z" fill="currentColor" />,
  },

  'line-solid-thin-arrow': {
    viewBox: '0 0 24 24',
    paths: <path d="m3 12 6 4.763V12.75h13v-1.5H9V7.237L3 12Z" fill="currentColor" />,
  },

  'line-solid-thick-arrow': {
    viewBox: '0 0 24 24',
    paths: <path d="m3 12 6 4.763V14h13v-4H9V7.237L3 12Z" fill="currentColor" />,
  },

  'line-solid': {
    viewBox: '0 0 24 24',
    paths: (
      <path fillRule="evenodd" d="M3 10.5v3h18v-3H3Z" clipRule="evenodd" fill="currentColor" />
    ),
  },

  'line-solid-thick': {
    viewBox: '0 0 24 24',
    paths: <path fillRule="evenodd" d="M3 10v4h18v-4H3Z" clipRule="evenodd" fill="currentColor" />,
  },

  'line-solid-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path fillRule="evenodd" d="M3 11.25v1.5h18v-1.5H3Z" clipRule="evenodd" fill="currentColor" />
    ),
  },

  'line-thick': {
    viewBox: '0 0 24 24',
    paths: <path fillRule="evenodd" d="M3 10v4h18v-4H3Z" clipRule="evenodd" fill="currentColor" />,
  },

  'line-thin': {
    viewBox: '0 0 24 24',
    paths: (
      <path fillRule="evenodd" d="M3 11.25v1.5h18v-1.5H3Z" clipRule="evenodd" fill="currentColor" />
    ),
  },

  'line-mixed': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M1.454.04.04 1.454 20.546 21.96l1.414-1.414L15.414 14H21.5v-2h-8.086l-2-2H21.5V8H9.414L1.454.04ZM3.586 8l2 2H.5V8h3.086ZM.5 12h7.086l2 2H.5v-2Z"
        fill="currentColor"
      />
    ),
  },

  'c2-column': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M8.219 3.063c-.572 0-1.031.46-1.031 1.03v2.063c0 .572.46 1.032 1.03 1.032V17.5a2.408 2.408 0 0 0 2.407 2.406h2.063c0 .572.46 1.032 1.03 1.032h2.063c.572 0 1.031-.46 1.031-1.032v-2.062c0-.572-.46-1.032-1.03-1.032h-2.063c-.572 0-1.031.46-1.031 1.032h-2.063a.345.345 0 0 1-.344-.344v-4.469h2.406c0 .572.46 1.031 1.032 1.031h2.062c.572 0 1.031-.46 1.031-1.03v-2.063c0-.572-.46-1.031-1.03-1.031h-2.063c-.572 0-1.031.46-1.031 1.03H10.28v-3.78c.572 0 1.031-.46 1.031-1.032V4.094c0-.572-.46-1.032-1.03-1.032H8.218Z"
      />
    ),
  },

  'c2-right-fanout': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m10.666 13.08.003.044v4.35a2.408 2.408 0 0 0 2.406 2.406h2.063c0 .571.46 1.031 1.03 1.031h2.063a1.03 1.03 0 0 0 1.032-1.031v-2.063c0-.571-.46-1.03-1.032-1.03H16.17c-.572 0-1.031.459-1.031 1.03h-2.063a.345.345 0 0 1-.344-.343v-4.417h2.375c0 .572.46 1.032 1.032 1.032H18.2c.39 0 .727-.214.903-.53.101-.16.16-.35.16-.554v-2.063c0-.571-.46-1.03-1.032-1.03H16.17c-.39 0-.727.213-.903.53-.092.145-.15.316-.158.5H12.73c0-.355-.01-.682-.03-.98V6.525c0-.189.154-.343.343-.343h2.062c0 .571.46 1.03 1.032 1.03H18.2c.572 0 1.031-.459 1.031-1.03V4.12c0-.571-.46-1.031-1.03-1.031h-2.063a1.03 1.03 0 0 0-1.032 1.031h-2.062a2.408 2.408 0 0 0-2.406 2.406v4.416H8.863c0-.571-.46-1.03-1.031-1.03H5.769c-.571 0-1.031.459-1.031 1.03v2.138c0 .571.46 1.031 1.031 1.031h2.063c.571 0 1.03-.46 1.03-1.031h1.804Z"
      />
    ),
  },

  'c2-dual-column': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M10.587 19.906c.528 0 1.016-.17 1.413-.458.397.288.885.458 1.412.458h2.063c0 .572.46 1.032 1.031 1.032h2.063c.571 0 1.03-.46 1.03-1.032v-2.062c0-.572-.459-1.032-1.03-1.032h-2.063a1.03 1.03 0 0 0-1.031 1.032h-2.063a.345.345 0 0 1-.343-.344v-4.469h2.406c0 .572.46 1.031 1.031 1.031h2.063c.571 0 1.03-.46 1.03-1.03v-2.063c0-.572-.459-1.031-1.03-1.031h-2.063c-.571 0-1.031.46-1.031 1.03h-2.406v-3.78c.571 0 1.03-.46 1.03-1.032V4.094c0-.572-.459-1.032-1.03-1.032H10.93a1.03 1.03 0 0 0-1.031 1.032v2.062c0 .572.46 1.032 1.031 1.032v3.78H8.525c0-.57-.46-1.03-1.031-1.03H5.43c-.571 0-1.031.46-1.031 1.03v2.063c0 .572.46 1.031 1.031 1.031h2.063c.571 0 1.03-.46 1.03-1.03h2.407V17.5c0 .19-.154.344-.344.344H8.525a1.03 1.03 0 0 0-1.031-1.032H5.43a1.03 1.03 0 0 0-1.031 1.032v2.062c0 .572.46 1.032 1.031 1.032h2.063c.571 0 1.03-.46 1.03-1.032h2.063Z"
      />
    ),
  },

  'c2-downward-fanout': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m10.92 10.666-.044.003h-4.35a2.408 2.408 0 0 0-2.406 2.406v2.063c-.571 0-1.031.46-1.031 1.03v2.063c0 .572.46 1.031 1.031 1.031h2.063c.571 0 1.03-.46 1.03-1.03v-2.063c0-.572-.459-1.032-1.03-1.032v-2.062c0-.19.154-.344.343-.344h4.417v2.375a1.03 1.03 0 0 0-1.032 1.031V18.2c0 .39.214.727.53.902.16.102.35.16.554.16h2.063c.571 0 1.03-.46 1.03-1.03v-2.063c0-.39-.213-.727-.53-.903a1.028 1.028 0 0 0-.5-.159v-2.376c.355 0 .682-.01.98-.031h3.436c.189 0 .343.155.343.344v2.062c-.571 0-1.03.46-1.03 1.031V18.2c0 .571.459 1.031 1.03 1.031h2.063c.572 0 1.031-.46 1.031-1.031v-2.063c0-.571-.46-1.03-1.031-1.03v-2.063a2.408 2.408 0 0 0-2.406-2.407h-4.416V8.863c.571 0 1.03-.46 1.03-1.032V5.77c0-.572-.459-1.031-1.03-1.031H10.92c-.571 0-1.031.46-1.031 1.03v2.063c0 .572.46 1.032 1.031 1.032v1.803Z"
      />
    ),
  },

  'c2-mixed': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fillRule="evenodd"
          d="M2.414.586 1 2l20.506 20.506 1.414-1.414-2.24-2.24c.145-.178.231-.404.231-.652v-2.063c0-.571-.46-1.03-1.031-1.03v-2.063a2.408 2.408 0 0 0-2.406-2.407h-4.416V8.863c.571 0 1.03-.46 1.03-1.032V5.77c0-.572-.459-1.031-1.03-1.031H10.92c-.571 0-1.031.46-1.031 1.03v2.063c0 .091.011.18.033.263L2.414.586Zm8.244 8.243.262.263v-.23a1.04 1.04 0 0 1-.262-.033Zm3.87 3.871 2.638 2.637c.177-.144.404-.23.651-.23v-2.063a.345.345 0 0 0-.343-.344h-2.946Z"
          clipRule="evenodd"
          fill="currentColor"
        />
        <path
          d="M6.526 10.669h.143L8.73 12.73H6.526a.345.345 0 0 0-.343.344v2.063c.571 0 1.03.46 1.03 1.03v2.063c0 .572-.459 1.031-1.03 1.031H4.12c-.571 0-1.031-.46-1.031-1.03v-2.063c0-.572.46-1.032 1.031-1.032v-2.062a2.408 2.408 0 0 1 2.406-2.406Zm4.417 4.437v-.163l3.146 3.146v.142c0 .572-.46 1.031-1.031 1.031h-2.063a1.02 1.02 0 0 1-.553-.16 1.029 1.029 0 0 1-.53-.902v-2.063c0-.571.459-1.03 1.03-1.03Z"
          fill="currentColor"
        />
      </>
    ),
  },

  'c2-relationship': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M18.35 2.478a1.377 1.377 0 0 1 1.5.297l2.75 2.75a1.373 1.373 0 0 1 0 1.942l-2.75 2.75a1.37 1.37 0 0 1-1.5.296 1.376 1.376 0 0 1-.85-1.272V7.875h-1.611c-.366 0-.714.146-.971.404L11.197 12l3.72 3.721c.258.258.606.404.972.404H17.5V14.75a1.377 1.377 0 0 1 2.35-.975l2.75 2.75a1.373 1.373 0 0 1 0 1.942l-2.75 2.75a1.37 1.37 0 0 1-1.5.296 1.376 1.376 0 0 1-.85-1.272v-1.366h-1.611a4.124 4.124 0 0 1-2.918-1.207L8.68 13.375H2.375C1.615 13.375 1 12.761 1 12c0-.76.614-1.375 1.375-1.375h6.304l4.292-4.293a4.123 4.123 0 0 1 2.918-1.207H17.5V3.75c0-.554.335-1.057.85-1.272Z"
      />
    ),
  },

  bomber: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="#019EFF"
        d="M1 1.178v6.695c0 .098.08.178.177.178h6.982c.097 0 .176.08.176.178v5.16c0 .16.19.239.302.127L20.739 1.303A.178.178 0 0 0 20.614 1H1.177A.177.177 0 0 0 1 1.178ZM22.822 23h-6.695a.177.177 0 0 1-.178-.177v-6.981a.177.177 0 0 0-.178-.177h-5.162a.176.176 0 0 1-.126-.301L22.697 3.262a.178.178 0 0 1 .304.125v19.436c0 .098-.08.177-.178.177Z"
      />
    ),
  },

  'star-slash': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m10.904 2.68-1.825 3.7 9.556 7.385 3.211-3.13c.726-.706.325-1.94-.675-2.085l-5.58-.813-2.495-5.057c-.447-.902-1.742-.913-2.192 0Zm7.72 16.63 2.813 2.174a.551.551 0 0 0 .772-.096l.675-.869a.55.55 0 0 0-.096-.772l-4.282-3.308L2.563 4.116a.55.55 0 0 0-.772.097l-.675.868a.55.55 0 0 0 .096.772l3.193 2.468-1.575.23c-1.001.144-1.402 1.378-.677 2.085l4.038 3.934-.955 5.557c-.172 1.005.886 1.757 1.772 1.287L12 18.79l4.992 2.624c.886.466 1.944-.282 1.772-1.287l-.14-.817Z"
        clipRule="evenodd"
      />
    ),
  },

  'set-aside': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M9.028 12.537H2.312a.309.309 0 0 1-.22-.094.323.323 0 0 1-.092-.226v-6.87a.517.517 0 0 1 .156-.343.494.494 0 0 1 .696.011l2.26 2.315.222-.228a10.065 10.065 0 0 1 4.55-2.772 9.49 9.49 0 0 1 .445-.109 10.49 10.49 0 0 1 3.97-.06 9.513 9.513 0 0 1 3.497 1.416 9.744 9.744 0 0 1 2.701 2.679 9.985 9.985 0 0 1 1.494 3.532.655.655 0 0 1-.139.522.624.624 0 0 1-.48.226h-1.183a.749.749 0 0 1-.464-.172.779.779 0 0 1-.262-.427 7.358 7.358 0 0 0-1.861-3.258 7.113 7.113 0 0 0-3.2-1.875c-1.208-.328-2.689-.327-3.896.005A7.114 7.114 0 0 0 7.31 8.693l-.432.443 2.47 2.53a.502.502 0 0 1 .148.359c0 .13-.049.256-.136.35a.495.495 0 0 1-.333.162Zm-6.403 4.906h18.741c.345 0 .625.286.625.639v1.279c0 .353-.28.639-.625.639H2.625A.632.632 0 0 1 2 19.36v-1.278c0-.353.28-.64.625-.64Z"
      />
    ),
  },

  'card-drag': {
    viewBox: '0 0 28 28',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1 10a2 2 0 012-2h3v10h17v4a2 2 0 01-2 2H3a2 2 0 01-2-2V10z"
          opacity=".4"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7 4a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2H7zm.25 3a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h5.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25h-5.5zM7 11.25a.25.25 0 01.25-.25h17.5a.25.25 0 01.25.25v1.5a.25.25 0 01-.25.25H7.25a.25.25 0 01-.25-.25v-1.5zM7.25 15a.25.25 0 00-.25.25v1.5c0 .138.112.25.25.25h15.5a.25.25 0 00.25-.25v-1.5a.25.25 0 00-.25-.25H7.25z"
          clipRule="evenodd"
        />
      </>
    ),
  },

  'card-stack': {
    viewBox: '0 0 28 28',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7.377 4a1.957 1.957 0 0 0-1.962 1.951V17.66c0 1.077.879 1.95 1.962 1.95h17.66A1.957 1.957 0 0 0 27 17.66V5.95A1.957 1.957 0 0 0 25.038 4H7.378Zm.246 2.927a.245.245 0 0 0-.246.244v1.463c0 .135.11.244.246.244h5.396c.135 0 .245-.11.245-.244V7.171a.245.245 0 0 0-.245-.244H7.623Zm-.246 4.146c0-.135.11-.244.246-.244h17.17c.135 0 .245.11.245.244v1.464c0 .134-.11.243-.245.243H7.622a.245.245 0 0 1-.246-.243v-1.464Zm.246 3.659a.245.245 0 0 0-.246.244v1.463c0 .135.11.244.246.244H22.83c.136 0 .246-.11.246-.244v-1.463a.245.245 0 0 0-.246-.244H7.623Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M3.453 8.39h-.245C1.988 8.39 1 9.373 1 10.585v11.22C1 23.017 1.988 24 3.208 24h17.17a2.201 2.201 0 0 0 2.207-2.195v-.244H6.396a2.935 2.935 0 0 1-2.943-2.927V8.39Z"
        />
      </>
    ),
  },

  undo: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m6.387 10.247 1.757 1.94c.53.586.53 1.538 0 2.124a1.271 1.271 0 0 1-1.922 0l-4.074-4.5a1.615 1.615 0 0 1 0-2.123L6.222 3.19a1.271 1.271 0 0 1 1.922 0c.53.586.53 1.538 0 2.123L6.387 7.248l8.863.002a7 7 0 1 1 0 14h-3.5a1.5 1.5 0 0 1 0-3h3.5a4 4 0 0 0 0-8l-8.863-.003Z"
      />
    ),
  },

  redo: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m17.613 10.247-1.757 1.94a1.615 1.615 0 0 0 0 2.124 1.27 1.27 0 0 0 1.922 0l4.074-4.5c.53-.585.53-1.537 0-2.123L17.778 3.19a1.271 1.271 0 0 0-1.922 0 1.615 1.615 0 0 0 0 2.123l1.757 1.936-8.863.002a7 7 0 1 0 0 14h3.5a1.5 1.5 0 0 0 0-3h-3.5a4 4 0 0 1 0-8l8.863-.003Z"
      />
    ),
  },

  'add-overlay': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M15 11h2.38c.31 0 .562-.252.563-.563v-.874A.563.563 0 0 0 17.378 9H15V6.623a.563.563 0 0 0-.563-.563h-.874a.563.563 0 0 0-.563.563V9h-2.377a.563.563 0 0 0-.563.563v.874c0 .31.252.563.563.563H13v2.38c0 .31.252.563.563.563h.874c.31 0 .563-.252.563-.564V11Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7 1a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H7Zm.25 2.25v13.5h13.5V3.25H7.25Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M3.125 20V5H.875v15c0 1.726 1.4 3.125 3.125 3.125h14v-2.25H4A.875.875 0 0 1 3.125 20Z"
        />
      </>
    ),
  },
  'convert-to-card': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3 3.625A1.63 1.63 0 0 1 4.636 2h14.728A1.63 1.63 0 0 1 21 3.625v9.75A1.63 1.63 0 0 1 19.364 15H17l-2.438-2.438h2.96c.114 0 .205-.09.205-.203v-1.218a.204.204 0 0 0-.204-.204H4.84a.204.204 0 0 0-.205.204v1.218c0 .113.092.204.205.204h4.597L7 15H4.636A1.63 1.63 0 0 1 3 13.375v-9.75Zm1.636 1.016c0-.113.092-.204.205-.204h4.5c.113 0 .204.091.204.204v1.218a.204.204 0 0 1-.204.204h-4.5a.204.204 0 0 1-.205-.204V4.641Zm.205 3.046a.204.204 0 0 0-.205.204v1.218c0 .113.092.204.205.204h14.318a.204.204 0 0 0 .205-.204V7.891a.204.204 0 0 0-.205-.204H4.841Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M12.53 13.033a.75.75 0 0 0-1.06 0L7.404 17.1a.5.5 0 0 0 0 .707l.884.884a.5.5 0 0 0 .707 0l1.88-1.88v5.193a.5.5 0 0 0 .5.5h1.25a.5.5 0 0 0 .5-.5V16.81l1.88 1.88a.5.5 0 0 0 .707 0l.884-.884a.5.5 0 0 0 0-.707l-4.066-4.066Z"
        />
      </>
    ),
  },
  classification: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M12 4.154a3.268 3.268 0 0 1 3.27 3.27v1.96H8.73v-1.96A3.268 3.268 0 0 1 12 4.153Zm-5.884 3.27v1.96h-.654A2.618 2.618 0 0 0 2.846 12v7.846a2.618 2.618 0 0 0 2.616 2.615h13.076a2.618 2.618 0 0 0 2.616-2.615V12a2.618 2.618 0 0 0-2.616-2.615h-.654V7.423A5.886 5.886 0 0 0 12 1.54a5.886 5.886 0 0 0-5.884 5.884Zm7.192 7.191v2.616c0 .723-.585 1.307-1.308 1.307a1.306 1.306 0 0 1-1.308-1.307v-2.616c0-.723.585-1.307 1.308-1.307.723 0 1.308.584 1.308 1.307Z"
      />
    ),
  },
  'no-classification': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M6.173 6.601a5.886 5.886 0 0 1 11.712.822v1.962h.653A2.618 2.618 0 0 1 21.154 12v6.784l1.916 1.558a1 1 0 0 1-1.262 1.552L1.678 5.524a1 1 0 0 1 1.263-1.551L6.173 6.6ZM12 4.154a3.268 3.268 0 0 1 3.27 3.27v1.96H9.594l-.864-.702V7.423A3.268 3.268 0 0 1 12 4.154Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M2.846 12c0-.685.264-1.308.696-1.775l7.15 5.815v1.19a1.306 1.306 0 0 0 2.383.747l5.513 4.484H5.462a2.618 2.618 0 0 1-2.616-2.615V12Z"
        />
      </>
    ),
  },
  'diagonal-negative': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m14.549 12.491 3.982 3.983 1.334-1.415c.65-.65 1.76-.19 1.76.73V20.6a1.03 1.03 0 0 1-1.031 1.029H15.78c-.918 0-1.379-1.109-.729-1.758l1.417-1.336-3.983-3.982a.688.688 0 0 1 0-.973l1.09-1.09a.687.687 0 0 1 .973 0ZM9.45 11.52 5.47 7.536 4.135 8.951c-.65.65-1.76.19-1.76-.73V3.41c0-.57.462-1.029 1.031-1.029H8.22c.919 0 1.379 1.109.729 1.758L7.531 5.474l3.983 3.982a.688.688 0 0 1 0 .973l-1.09 1.09a.687.687 0 0 1-.973 0Z"
      />
    ),
  },
  centered: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M13.281 13.893v4.967l1.714-.05c.81 0 1.216.979.643 1.552l-3.001 3.001a.908.908 0 0 1-1.285-.001L8.35 20.36c-.573-.573-.169-1.552.641-1.552l1.717.05v-4.966c0-.335.271-.607.606-.607h1.36c.335 0 .606.272.606.607Zm-2.572-3.786V5.14l-1.714.05c-.81 0-1.216-.979-.643-1.552L11.353.637a.908.908 0 0 1 1.285.001L15.64 3.64c.573.573.169 1.552-.641 1.552L13.28 5.14v4.967a.606.606 0 0 1-.606.607h-1.36a.606.606 0 0 1-.606-.607Z"
      />
    ),
  },
  'diagonal-positive': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M11.509 14.549 7.526 18.53l1.415 1.334c.65.65.19 1.76-.73 1.76H3.4a1.03 1.03 0 0 1-1.029-1.031V15.78c0-.918 1.109-1.379 1.758-.729l1.336 1.417 3.982-3.983a.688.688 0 0 1 .973 0l1.09 1.09a.687.687 0 0 1 0 .973Zm.972-5.098 3.983-3.982-1.415-1.334c-.65-.65-.19-1.76.73-1.76h4.812c.57 0 1.029.462 1.029 1.031V8.22c0 .919-1.109 1.379-1.758.729l-1.336-1.417-3.982 3.983a.688.688 0 0 1-.973 0l-1.09-1.09a.687.687 0 0 1 0-.973Z"
      />
    ),
  },
  'corner-resize': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M17 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm5 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-5-9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      />
    ),
  },
  duplicate: {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M6.125 4.75v11a2.753 2.753 0 0 0 2.75 2.75h11a2.753 2.753 0 0 0 2.75-2.75v-11A2.753 2.753 0 0 0 19.875 2h-11a2.753 2.753 0 0 0-2.75 2.75ZM13 6.813a.69.69 0 0 1 .688-.688h1.374a.69.69 0 0 1 .688.688v2.062h2.063a.69.69 0 0 1 .687.688v1.374a.69.69 0 0 1-.688.688H15.75v2.063a.69.69 0 0 1-.688.687h-1.374a.69.69 0 0 1-.688-.688v-2.062h-2.063a.69.69 0 0 1-.687-.688V9.563a.69.69 0 0 1 .688-.688H13V6.812Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M15.75 21.594a1.03 1.03 0 0 0-1.031-1.032H7.844a3.781 3.781 0 0 1-3.782-3.78V7.155A1.03 1.03 0 1 0 2 7.156v9.625a5.844 5.844 0 0 0 5.844 5.844h6.875c.571 0 1.031-.46 1.031-1.031Z"
        />
      </>
    ),
  },
  'zoom-in': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m22.497 20.065-5.143-5.143a8.935 8.935 0 0 0 1.438-6.218c-.526-3.934-3.75-7.133-7.687-7.631a8.94 8.94 0 0 0-10.03 10.029c.5 3.938 3.699 7.163 7.632 7.687a8.932 8.932 0 0 0 6.217-1.438l5.144 5.144a1.719 1.719 0 1 0 2.43-2.43Zm-9.122-9.096H10.93v2.406c0 .57-.461 1.031-.992 1.031a1.03 1.03 0 0 1-1.032-1.031v-2.406H6.461c-.532 0-.992-.46-.992-1.032 0-.571.461-1.03.992-1.03h2.445V6.5c0-.57.462-1.031.993-1.031.531 0 1.031.46 1.031 1.031v2.406h2.406c.61 0 1.07.46 1.07 1.031a1.03 1.03 0 0 1-1.031 1.032Z"
      />
    ),
  },
  'zoom-out': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M18.875 9.938c0 1.972-.64 3.794-1.719 5.272l5.44 5.444A1.377 1.377 0 0 1 20.65 22.6l-5.44-5.444a8.886 8.886 0 0 1-5.273 1.719C5 18.875 1 14.875 1 9.937 1 5 5 1 9.938 1c4.937 0 8.937 4 8.937 8.938ZM6.844 8.905a1.03 1.03 0 0 0-1.032 1.031c0 .572.46 1.032 1.032 1.032h6.187c.572 0 1.031-.46 1.031-1.031 0-.572-.46-1.032-1.03-1.032H6.843Z"
      />
    ),
  },
  sync: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M1.069 10.191c-.24.722.15 1.5.868 1.74.717.24 1.5-.15 1.74-.868a4.662 4.662 0 0 1 4.421-3.188h7.455l-1.778 1.779A1.377 1.377 0 0 0 15.72 11.6l4.125-4.125a1.377 1.377 0 0 0 0-1.946L15.72 1.404a1.377 1.377 0 0 0-1.946 1.946l1.778 1.775H8.098a7.413 7.413 0 0 0-7.03 5.066Zm21.858 3.618c.24-.722-.15-1.5-.868-1.74s-1.5.15-1.74.868a4.653 4.653 0 0 1-4.417 3.188H8.445l1.78-1.779A1.377 1.377 0 0 0 8.278 12.4l-4.125 4.125a1.377 1.377 0 0 0 0 1.946l4.125 4.125a1.377 1.377 0 0 0 1.946-1.946l-1.779-1.775h7.456a7.413 7.413 0 0 0 7.03-5.066h-.005Z"
      />
    ),
  },
  'sync-circle': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM5.598 11.956a.876.876 0 0 1-.553-1.107A4.717 4.717 0 0 1 9.52 7.625h4.744l-1.132-1.13a.876.876 0 0 1 1.238-1.239l2.625 2.626a.876.876 0 0 1 0 1.238l-2.625 2.626a.876.876 0 0 1-1.238-1.24l1.132-1.131H9.519a2.967 2.967 0 0 0-2.814 2.029.877.877 0 0 1-1.107.552Zm12.805.088a.876.876 0 0 1 .552 1.107h.003a4.717 4.717 0 0 1-4.474 3.224H9.74l1.132 1.13a.876.876 0 0 1-1.239 1.239l-2.625-2.626a.876.876 0 0 1 0-1.238l2.625-2.626a.876.876 0 0 1 1.24 1.24l-1.133 1.13h4.744a2.961 2.961 0 0 0 2.811-2.029.877.877 0 0 1 1.107-.552Z"
        clipRule="evenodd"
      />
    ),
  },
  unsync: {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1.069 10.191c-.24.722.15 1.5.868 1.74.717.24 1.5-.15 1.74-.868A4.665 4.665 0 0 1 5.59 8.607L3.347 6.85a7.403 7.403 0 0 0-2.278 3.342Zm7.377 5.934h6.74l3.036 2.378a7.396 7.396 0 0 1-2.32.372H8.445l1.78 1.775a1.377 1.377 0 0 1-1.947 1.946l-4.125-4.125a1.377 1.377 0 0 1 0-1.946L8.279 12.4a1.377 1.377 0 0 1 1.946 1.946l-1.779 1.779Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M19.223 14.732a4.644 4.644 0 0 0 1.096-1.795 1.378 1.378 0 0 1 1.74-.868 1.377 1.377 0 0 1 .868 1.74h.004a7.399 7.399 0 0 1-1.511 2.601c.689.524 1.44 1.093 2.264 1.715.357.282.423.801.109 1.128a.824.824 0 0 1-1.158.14L2.315 3.474a.825.825 0 1 1 1.02-1.298C4.794 3.32 6.051 4.31 7.156 5.185c.31-.04.624-.06.941-.06h7.455L13.775 3.35a1.377 1.377 0 0 1 1.946-1.946l4.125 4.125c.537.537.537 1.41 0 1.946L15.721 11.6c-.08.08-.166.148-.258.203 1.098.869 2.27 1.784 3.76 2.929Zm-5.782-4.538-1.004-.804-1.894-1.515h5.01l-1.778 1.779a1.37 1.37 0 0 0-.334.54Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'new-slide': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M15.494 12.994 13 13l-.006 2.494c0 .28-.227.506-.506.506H11.5a.506.506 0 0 1-.506-.506L11 13l-2.494-.006A.506.506 0 0 1 8 12.488V11.5c0-.28.227-.506.506-.506L11 11l-.006-2.494c0-.28.227-.506.506-.506h.988c.28 0 .506.227.506.506L13 11l2.494-.006c.28 0 .506.227.506.506v.988c0 .28-.227.506-.506.506Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M1 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5Zm2 0h18v14H3V5Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'file-kml': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM2.913 9.239a.817.817 0 0 0-.05-.035c.025-.082.05-.165.073-.249.046-.16.092-.32.15-.475.47-1.282 1.26-2.368 2.26-3.28.285-.26.753-.353 1.161-.434l.03-.006c1.676-.336 3.25-.127 4.595 1.02.474.406.938.823 1.402 1.24.504.455 1.007.908 1.526 1.347 1.435 1.212 2.875 2.42 4.354 3.576a7.124 7.124 0 0 0 2.758 1.322c.196.043.284.13.218.362a7.44 7.44 0 0 0-.135.645c-.026.144-.052.289-.083.432-.057.266-.188.34-.484.284a15.524 15.524 0 0 1-5.315-2.124c-1.311-.82-2.59-1.69-3.867-2.56-.734-.5-1.467-.998-2.207-1.488a13.76 13.76 0 0 0-1.444-.811c-1.458-.733-2.775-.44-3.989.567-.102.083-.2.17-.298.257-.099.087-.197.174-.3.257-.062.05-.134.091-.205.13a3.032 3.032 0 0 0-.1.058l-.05-.035Zm16.902 8.082.057.061-.125.17c-.148.2-.297.4-.43.615-.754 1.112-1.937 1.348-3.145 1.531-2.287.345-4.53.074-6.746-.497a4.95 4.95 0 0 0-.352-.08 3.333 3.333 0 0 1-.032-.007c-.925-.188-1.292.187-1.065 1.086a6.621 6.621 0 0 1 .096.47 7.578 7.578 0 0 0-.229-.076 1.593 1.593 0 0 1-.29-.11 9.52 9.52 0 0 1-3.967-3.9c-.397-.724.061-1.566.895-1.51.624.04 1.256.25 1.841.49.226.092.451.185.677.279 1.621.673 3.242 1.345 4.974 1.674 1.143.214 2.304.375 3.464.432 1.344.066 2.658-.244 3.954-.598.081-.023.163-.042.244-.061l.122-.03c.02.02.039.04.057.061ZM9.279 2.967a2.482 2.482 0 0 0-.01-.083c.146-.033.293-.07.439-.107.315-.079.63-.158.952-.202 2.688-.358 5.11.335 7.248 1.975a9.03 9.03 0 0 1 3.116 4.366c.17.502.117.76-.214 1.03a.82.82 0 0 1-1.091-.014c-.48-.405-.92-.863-1.318-1.347-.35-.422-.685-.858-1.02-1.294-.531-.69-1.062-1.38-1.65-2.017-1.23-1.339-2.84-1.993-4.66-2.102a56.962 56.962 0 0 0-.896-.045l-.597-.03a1.207 1.207 0 0 1-.205-.03 3.36 3.36 0 0 0-.083-.017 2.456 2.456 0 0 1-.01-.083Z"
        clipRule="evenodd"
      />
    ),
  },
  'file-shp': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M16.05 16.947h.731c.452 0 .738.314.738.724s-.286.725-.738.725h-.73v-1.45Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M4 3.75A2.753 2.753 0 0 1 6.75 1h7.111c.73 0 1.431.288 1.947.804l3.889 3.888c.515.516.803 1.216.803 1.947V20.25A2.753 2.753 0 0 1 17.75 23h-11A2.753 2.753 0 0 1 4 20.25V3.75Zm14.438 10.412V7.875H15c-.76 0-1.375-.614-1.375-1.375V3.062H6.75a.69.69 0 0 0-.688.688v10.412h12.375ZM5.87 17.514c0-.957.823-1.552 1.776-1.552.4 0 1.404.144 1.404.684 0 .266-.187.506-.48.506a1.15 1.15 0 0 1-.384-.088 1.609 1.609 0 0 0-.569-.117c-.308 0-.587.157-.587.444 0 .273.359.372.798.494.696.193 1.594.442 1.594 1.523 0 .977-.845 1.586-1.833 1.586-.552 0-1.74-.123-1.74-.766 0-.267.185-.485.479-.485.155 0 .323.056.505.117.214.071.447.15.698.15.473 0 .73-.254.73-.589 0-.335-.414-.447-.898-.578-.678-.183-1.493-.403-1.493-1.329Zm4.999 3.439c-.308 0-.537-.192-.537-.534v-3.883c0-.341.229-.533.537-.533.308 0 .537.192.537.533v1.45h1.668v-1.45c0-.341.23-.533.537-.533.308 0 .537.192.537.533v3.883c0 .342-.229.534-.537.534-.308 0-.537-.192-.537-.534v-1.49h-1.668v1.49c0 .342-.23.534-.537.534Zm4.106-.534c0 .342.23.534.537.534.309 0 .538-.192.538-.534V19.3h.795c.98 0 1.79-.623 1.79-1.621 0-.978-.78-1.634-1.833-1.634h-1.268c-.358 0-.559.212-.559.533v3.842Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M8.113 9.86h2.291a.459.459 0 0 1 .459.459v2.291a.459.459 0 0 1-.459.459H8.113a.459.459 0 0 1-.459-.459v-2.29a.458.458 0 0 1 .459-.459Zm1.144-4.786L7.726 7.693a.524.524 0 0 0 .46.785h3.062a.524.524 0 0 0 .46-.785l-1.532-2.62a.534.534 0 0 0-.919 0Zm6.274 4.637a1.833 1.833 0 1 0-2.037 3.048 1.833 1.833 0 0 0 2.037-3.048Z"
        />
      </>
    ),
  },
  'line-numbers': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          d="m4.907 17.368-.752.865v.001c.843.22 1.233.88 1.235 1.498 0 .919-.617 1.896-2.084 1.896-.714 0-1.259-.204-1.59-.406-.25-.181-.273-.421-.113-.685l.24-.4c.166-.284.391-.3.67-.134.211.087.437.132.665.134.437 0 .617-.15.617-.353 0-.285-.241-.39-.685-.39h-.203c-.256 0-.398-.092-.526-.339l-.045-.083c-.106-.204-.052-.421.12-.64l.241-.3c.148-.184.306-.361.472-.529h-.981a.344.344 0 0 1-.343-.344v-.687a.344.344 0 0 1 .343-.344h2.45c.322 0 .487.172.487.488v.142a.856.856 0 0 1-.218.61Zm.032-9.49h-2.75a.346.346 0 0 1-.344-.344v-.687a.344.344 0 0 1 .343-.344h.688v-2.75h-.344a.344.344 0 0 1-.307-.498l.344-.687a.344.344 0 0 1 .307-.19h1.031a.344.344 0 0 1 .344.344v3.781h.688a.344.344 0 0 1 .343.344v.687a.344.344 0 0 1-.343.344Zm-.001 6.875H2.02c-.302 0-.52-.172-.52-.49v-.172c0-1.338.95-1.965 1.6-2.393.336-.222.591-.39.591-.577 0-.309-.257-.376-.4-.376a.577.577 0 0 0-.406.165c-.22.211-.452.301-.692.105l-.37-.296c-.249-.195-.308-.42-.12-.66.286-.376.821-.806 1.739-.806.836 0 1.911.451 1.911 1.7 0 1.103-.895 1.623-1.513 1.981-.29.17-.52.303-.565.444h1.664a.344.344 0 0 1 .343.344v.687a.344.344 0 0 1-.344.344Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          d="M22.5 19.597V7.273a1.79 1.79 0 0 0-.514-1.258L18.927 2.9a1.735 1.735 0 0 0-1.236-.523H10.25c-.966 0-1.75.798-1.75 1.781v15.438c0 .983.784 1.781 1.75 1.781h10.5c.966 0 1.75-.798 1.75-1.781ZM17.833 7.128V4.304l2.775 2.824h-2.775Zm2.917 1.781v10.688h-10.5V4.159h5.833v3.86c0 .493.39.89.875.89h3.792Z"
          clipRule="evenodd"
          fill="currentColor"
        />
      </>
    ),
  },
  'list-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.552 2.98h14.896c.95 0 1.719.769 1.719 1.718v6.567h-2.292V7.562h-5.729v4.748A5.302 5.302 0 0 0 9 16.575V7.562H3.125v9.167H9v-.154c0 .882.215 1.714.595 2.446H2.552a1.72 1.72 0 0 1-1.719-1.719V4.698c0-.95.77-1.719 1.72-1.719Z"
        />
        <path
          fill="currentColor"
          d="M11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'whiteboard-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M4.167 4c-1.165 0-2.111.96-2.111 2.143v9.643h2.11V6.143h12.667v5.122h2.111V6.143c0-1.182-.946-2.143-2.11-2.143H4.166Zm5.168 10.714A5.3 5.3 0 0 0 9 16.575c0 .874.21 1.698.584 2.425H2.056A1.062 1.062 0 0 1 1 17.929c0-.593.472-1.072 1.056-1.072h5.222v-1.071c0-.593.471-1.072 1.055-1.072h1.002ZM11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'c2-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M9.444 2.797c-.874 0-1.583.72-1.583 1.607v2.143c0 .887.71 1.607 1.583 1.607h.264v1.34H4.694c-1.019 0-1.847.84-1.847 1.874v1.072h-.264C1.71 12.44 1 13.16 1 14.047v2.143c0 .887.71 1.607 1.583 1.607h2.111c.875 0 1.584-.72 1.584-1.607v-2.143c0-.887-.71-1.607-1.584-1.607h-.263v-1.072c0-.147.118-.268.263-.268h5.014v1.34h-.264c-.874 0-1.583.72-1.583 1.607v2.143a1.6 1.6 0 0 0 1.273 1.576 5.304 5.304 0 0 1 2.158-5.56V11.1h5.014c.109 0 .203.069.243.165h1.601c-.053-.987-.86-1.772-1.844-1.772h-5.014V8.154h.264c.874 0 1.583-.72 1.583-1.607V4.404c0-.887-.71-1.607-1.583-1.607H9.444Z"
        />
        <path
          fill="currentColor"
          d="M11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'c2-text-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1.042 3.874c0-.484.39-.874.873-.874h1.748c.484 0 .874.39.874.874V5.62c0 .485-.39.874-.874.874V9.7h2.039c0-.484.39-.873.874-.873h1.747c.485 0 .874.39.874.873v1.748c0 .484-.39.874-.873.874H6.575a.872.872 0 0 1-.874-.874H3.663v3.787c0 .16.131.29.291.29h1.748c0-.483.39-.873.874-.873h1.747c.485 0 .874.39.874.874v1.748c0 .484-.39.873-.873.873H6.575a.872.872 0 0 1-.874-.873H3.954a2.04 2.04 0 0 1-2.039-2.04V6.496a.872.872 0 0 1-.873-.874V3.874Zm6.99 2.039a1.164 1.164 0 1 1 0-2.33h10.486c.645 0 1.165.52 1.165 1.165 0 .644-.52 1.165-1.165 1.165H8.032Zm4.661 5.825a1.164 1.164 0 1 1 0-2.33h5.825c.645 0 1.165.52 1.165 1.165s-.52 1.165-1.165 1.165h-5.825ZM11 16.81a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31A3.31 3.31 0 0 1 11 16.81Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M18.944 16.148h-3.972a.661.661 0 1 0 0 1.324h3.972a.661.661 0 1 0 0-1.324Z"
        />
      </>
    ),
  },
  'section-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M19.333 11.265V7.58a2.294 2.294 0 0 0-2.291-2.292h-5.35c-.609 0-1.192-.24-1.622-.67l-.949-.948A2.292 2.292 0 0 0 7.5 3H3.292A2.294 2.294 0 0 0 1 5.292V16.75a2.294 2.294 0 0 0 2.292 2.292h6.314A5.289 5.289 0 0 1 9 16.575c0-1.821.916-3.427 2.313-4.384V8.156c0-.315.257-.573.572-.573h4.584c.315 0 .573.258.573.573v3.109h2.291Z"
        />
        <path
          fill="currentColor"
          d="M11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'ce-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M13.806 11.289a5.274 5.274 0 0 0-1.809.504 1.375 1.375 0 1 0-1.662 1.26 5.309 5.309 0 0 0-.978 1.604 3.207 3.207 0 0 1-1.94-2.949c0-1.037.501-1.95 1.266-2.535L7.508 6.658a.32.32 0 0 0-.045.004.32.32 0 0 1-.046.005 1.835 1.835 0 0 1-1.834-1.834C5.583 3.823 6.405 3 7.417 3c1.01 0 1.833.822 1.833 1.833 0 .482-.19.917-.493 1.244L9.926 8.58a3.14 3.14 0 0 1 .699-.083 3.207 3.207 0 0 1 3.181 2.792Zm5.527-4.622A1.835 1.835 0 0 1 17.5 8.5a1.835 1.835 0 0 1-1.833-1.833c0-1.012.822-1.834 1.833-1.834 1.011 0 1.833.822 1.833 1.834ZM1 11.708c0-1.01.822-1.833 1.833-1.833 1.012 0 1.834.822 1.834 1.833a1.835 1.835 0 0 1-1.834 1.834A1.835 1.835 0 0 1 1 11.708ZM15.713 8.81l-.55-.734-1.376 1.031.55.734 1.376-1.032ZM5.354 12.167H6.73v-.917H5.354v.917ZM11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'timeline-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M2.688 5C1.756 5 1 5.728 1 6.625v2.167c0 .897.756 1.625 1.688 1.625h14.624c.932 0 1.688-.728 1.688-1.625V6.625C19 5.728 18.244 5 17.312 5H2.688ZM16.75 8.25h-4.5V7.167h4.5V8.25Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M9.193 18H2.688C1.756 18 1 17.272 1 16.375v-2.167c0-.897.756-1.625 1.688-1.625h8.12a5.319 5.319 0 0 0-1.486 2.167H7v1.083h2.051A5.36 5.36 0 0 0 9.193 18ZM11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'orders-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2 3.943C2 2.87 2.895 2 4 2h6.95c.53 0 1.039.205 1.414.57l5.05 4.906c.375.365.586.859.586 1.374v2.415h-1.778V8.909h-4.666a.657.657 0 0 1-.667-.648V3.727H4a.22.22 0 0 0-.222.216v15.114c0 .12.1.216.222.216h5.735A5.334 5.334 0 0 0 11.373 21H4c-1.105 0-2-.87-2-1.943V3.943Z"
        />
        <path
          fill="currentColor"
          d="M6 11.818h5.947a5.34 5.34 0 0 0-1.999 1.728H6a.438.438 0 0 1-.444-.432v-.864c0-.239.199-.432.444-.432Zm0 3.455h3.16A5.324 5.324 0 0 0 9.018 17H6a.438.438 0 0 1-.444-.432v-.864c0-.238.199-.431.444-.431Zm8.31-2.008a3.31 3.31 0 1 0 0 6.62h1.324a.661.661 0 1 0 0-1.324H14.31a1.987 1.987 0 0 1 0-3.972h1.324a.661.661 0 1 0 0-1.324H14.31Zm8.607 3.31a3.31 3.31 0 0 1-3.31 3.31h-1.325a.661.661 0 1 1 0-1.324h1.325a1.987 1.987 0 0 0 0-3.972h-1.325a.661.661 0 1 1 0-1.324h1.325a3.31 3.31 0 0 1 3.31 3.31Z"
        />
        <path
          fill="currentColor"
          d="M18.944 15.913h-3.972a.661.661 0 1 0 0 1.324h3.972a.661.661 0 1 0 0-1.324Z"
        />
      </>
    ),
  },
  'presentation-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1.99 3h16.296c.592 0 1.047.456 1.047 1.019a1.02 1.02 0 0 1-1.018 1.02v6.226h-2.037V5.037H4.056v7.13h7.292A5.304 5.304 0 0 0 9 16.575c0 .535.08 1.052.226 1.539l-1.034 1.034c-.2.2-.525.2-.724 0l-.717-.717a.512.512 0 0 1 0-.723l2.397-2.398v-1.106H3.037c-.56 0-1.018-.459-1.018-1.019l-.03-8.176c-.533 0-.989-.457-.989-1.02C1 3.457 1.456 3 1.99 3Z"
        />
        <path
          fill="currentColor"
          d="M11 16.81a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31A3.31 3.31 0 0 1 11 16.81Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 16.148h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  'map-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1 11.167A9.166 9.166 0 0 1 10.167 2a9.166 9.166 0 0 1 9.16 9.5h-3.435a1.159 1.159 0 0 1-.197-.358l-.605-1.816c-.19-.573.1-1.2.663-1.425l.918-.367a7.446 7.446 0 0 0-6.131-3.806l.085.149c.24.42.19.946-.125 1.314l-.563.658a1.144 1.144 0 0 0-.01 1.48l.487.58a.688.688 0 0 1 .043.82.688.688 0 0 1-.784.268L8.81 8.72a.92.92 0 0 0-.73.054l-.216.104a.729.729 0 0 0-.036 1.278l1.236.709c.347.197.741.268 1.106.268h1.576c.454 0 .895.215 1.217.537a5.312 5.312 0 0 0-3.956 5.408.824.824 0 0 1-.018-.172v-1.089c0-.394-.19-.752-.573-.927-.319-.176-.573-.534-.573-.928v-1.428c0-.641-.39-1.204-1.039-1.38l-2.04-.59a2.293 2.293 0 0 1-1.362-1.067l-.336-.587a7.448 7.448 0 0 0 6.23 9.653 5.29 5.29 0 0 0 1.04 1.768A9.166 9.166 0 0 1 1 11.167Zm17.214 2.336a.696.696 0 0 1 .068-.003h1.325a3.31 3.31 0 1 1 0 6.62h-1.325a.661.661 0 1 1 0-1.324h1.325a1.987 1.987 0 0 0 0-3.972h-1.325a.661.661 0 0 1-.662-.662v-.014"
        />
        <path
          fill="currentColor"
          d="M18.214 13.503a.661.661 0 0 0-.593.645Zm-3.242 2.645a.661.661 0 1 0 0 1.324h3.972a.661.661 0 1 0 0-1.324h-3.972Z"
        />
        <path
          fill="currentColor"
          d="M12.824 18.127c.364.41.895.67 1.486.67h1.324a.661.661 0 1 1 0 1.323H14.31a3.303 3.303 0 0 1-2.846-1.618A3.29 3.29 0 0 1 11 16.81a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0-1.486 3.303Z"
        />
      </>
    ),
  },
  'file-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1 4.444A2.447 2.447 0 0 1 3.444 2h6.112v4.889a1.22 1.22 0 0 0 1.222 1.222h4.889V11.5H14.31A5.31 5.31 0 0 0 9 16.81a5.31 5.31 0 0 0 2.924 4.746h-8.48A2.447 2.447 0 0 1 1 19.11V4.444Z"
        />
        <path
          fill="currentColor"
          d="M15.667 6.889h-4.89V2l4.89 4.889ZM11 16.81a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31A3.31 3.31 0 0 1 11 16.81Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M18.944 16.148h-3.972a.661.661 0 1 0 0 1.324h3.972a.661.661 0 1 0 0-1.324Z"
        />
      </>
    ),
  },
  'plan-x': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M19.333 11.265V7.58a2.294 2.294 0 0 0-2.291-2.292h-5.35c-.609 0-1.192-.24-1.622-.67l-.949-.948A2.292 2.292 0 0 0 7.5 3H3.292A2.294 2.294 0 0 0 1 5.292V16.75a2.294 2.294 0 0 0 2.292 2.292h6.314A5.289 5.289 0 0 1 9 16.575c0-1.821.916-3.427 2.313-4.384 1.431-.926 2.687-.926 5.729-.926h2.291Z"
        />
        <path
          fill="currentColor"
          d="M11 16.575a3.31 3.31 0 0 1 3.31-3.31h1.324a.661.661 0 1 1 0 1.324H14.31a1.987 1.987 0 0 0 0 3.972h1.324a.661.661 0 1 1 0 1.324H14.31a3.31 3.31 0 0 1-3.31-3.31Zm8.607 3.31a3.31 3.31 0 1 0 0-6.62h-1.325a.661.661 0 1 0 0 1.324h1.325a1.987 1.987 0 0 1 0 3.972h-1.325a.661.661 0 1 0 0 1.324h1.325Z"
        />
        <path
          fill="currentColor"
          d="M14.972 15.913h3.972a.661.661 0 1 1 0 1.324h-3.972a.661.661 0 1 1 0-1.324Z"
        />
      </>
    ),
  },
  list: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M20.125 3H3.875C2.839 3 2 3.863 2 4.929V19.07C2 20.137 2.84 21 3.875 21h16.25C21.16 21 22 20.137 22 19.071V4.93C22 3.863 21.16 3 20.125 3ZM10.75 18.429H4.5V8.143h6.25v10.286Zm8.75 0h-6.25V8.143h6.25v10.286Z"
      />
    ),
  },
  whiteboard: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M4.667 3.222a2.447 2.447 0 0 0-2.445 2.445v11h2.445v-11h14.666v11h2.445v-11a2.447 2.447 0 0 0-2.445-2.445H4.667Zm4.889 13.445v1.222H2.222A1.22 1.22 0 0 0 1 19.11a1.22 1.22 0 0 0 1.222 1.222h19.556A1.22 1.22 0 0 0 23 19.111a1.22 1.22 0 0 0-1.222-1.222h-4.89v-1.222a1.22 1.22 0 0 0-1.221-1.223h-4.89a1.22 1.22 0 0 0-1.221 1.223Z"
      />
    ),
  },
  c2: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M8.944 5.056c0-1.013.822-1.834 1.834-1.834h2.444c1.012 0 1.834.821 1.834 1.834V7.5a1.834 1.834 0 0 1-1.834 1.833h-.305v1.528h5.805A2.14 2.14 0 0 1 20.862 13v1.222h.305c1.012 0 1.833.821 1.833 1.833V18.5a1.834 1.834 0 0 1-1.833 1.833h-2.445A1.834 1.834 0 0 1 16.89 18.5v-2.445c0-1.012.821-1.833 1.833-1.833h.306V13a.306.306 0 0 0-.306-.306h-5.805v1.528h.305c1.012 0 1.834.821 1.834 1.833V18.5a1.834 1.834 0 0 1-1.834 1.833h-2.444A1.834 1.834 0 0 1 8.944 18.5v-2.445c0-1.012.822-1.833 1.834-1.833h.305v-1.528H5.278a.306.306 0 0 0-.306.306v1.222h.306c1.012 0 1.833.821 1.833 1.833V18.5a1.834 1.834 0 0 1-1.833 1.833H2.833A1.834 1.834 0 0 1 1 18.5v-2.445c0-1.012.821-1.833 1.833-1.833h.306V13a2.14 2.14 0 0 1 2.139-2.139h5.805V9.333h-.305A1.834 1.834 0 0 1 8.944 7.5V5.056Z"
      />
    ),
  },
  'c2-text': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M2.948 3.063c-.571 0-1.031.46-1.031 1.03v2.063c0 .572.46 1.032 1.031 1.032V17.5a2.408 2.408 0 0 0 2.406 2.406h2.063c0 .572.46 1.032 1.031 1.032h2.063c.571 0 1.03-.46 1.03-1.032v-2.062c0-.572-.459-1.032-1.03-1.032H8.447a1.03 1.03 0 0 0-1.031 1.032H5.354a.345.345 0 0 1-.343-.344v-4.469h2.406c0 .572.46 1.031 1.031 1.031h2.063c.571 0 1.03-.46 1.03-1.03v-2.063c0-.572-.459-1.031-1.03-1.031H8.447c-.571 0-1.031.46-1.031 1.03H5.01v-3.78c.571 0 1.03-.46 1.03-1.032V4.094c0-.572-.459-1.032-1.03-1.032H2.948Zm5.844 2.062c0 .76.614 1.375 1.375 1.375h12.375a1.374 1.374 0 1 0 0-2.75H10.167c-.76 0-1.375.614-1.375 1.375Zm5.5 6.875c0 .76.614 1.375 1.375 1.375h6.875a1.374 1.374 0 1 0 0-2.75h-6.875c-.76 0-1.375.614-1.375 1.375Zm0 6.875c0 .76.614 1.375 1.375 1.375h6.875a1.374 1.374 0 1 0 0-2.75h-6.875c-.76 0-1.375.614-1.375 1.375Z"
      />
    ),
  },
  section: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M20.25 21.625H3.75A2.753 2.753 0 0 1 1 18.875V5.125a2.753 2.753 0 0 1 2.75-2.75h5.049c.73 0 1.43.288 1.946.804l1.139 1.138a2.75 2.75 0 0 0 1.947.804h6.419A2.753 2.753 0 0 1 23 7.87v11.004a2.753 2.753 0 0 1-2.75 2.75ZM13.375 8.562v6.876c0 .262.146.498.378.614.232.116.511.09.722-.064l2.338-1.754 2.337 1.754c.206.154.486.18.722.064a.677.677 0 0 0 .378-.614V8.561a.69.69 0 0 0-.688-.687h-5.5a.69.69 0 0 0-.687.688Z"
      />
    ),
  },
  ce: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M20.8 9.8c1.213 0 2.2-.987 2.2-2.2s-.987-2.2-2.2-2.2-2.2.987-2.2 2.2.987 2.2 2.2 2.2ZM3.2 11.45c-1.213 0-2.2.987-2.2 2.2s.987 2.2 2.2 2.2 2.2-.987 2.2-2.2-.987-2.2-2.2-2.2Zm15.455-1.279-.66-.88-1.65 1.238.66.88 1.65-1.238ZM20.8 16.4c-.495 0-.949.172-1.317.447l-3.3-1.98c.131-.385.217-.79.217-1.22a3.848 3.848 0 0 0-3.85-3.85c-.289 0-.57.037-.839.1L10.31 6.891c.364-.392.591-.914.591-1.492 0-1.213-.987-2.2-2.2-2.2s-2.2.987-2.2 2.2.987 2.2 2.2 2.2c.038 0 .072-.01.11-.01l1.41 3.018A3.822 3.822 0 0 0 8.7 13.65a3.848 3.848 0 0 0 3.85 3.85c1.103 0 2.09-.47 2.791-1.213l3.293 1.976c-.017.11-.034.224-.034.337 0 1.213.987 2.2 2.2 2.2s2.2-.986 2.2-2.2c0-1.213-.987-2.2-2.2-2.2Zm-8.25-1.1a1.65 1.65 0 1 1 0-3.3 1.65 1.65 0 0 1 0 3.3Zm-6.325-1.1h1.65v-1.1h-1.65v1.1Z"
      />
    ),
  },
  timeline: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M20.25 7.875h-5.5V6.5h5.5v1.375ZM3.062 3.75A2.063 2.063 0 0 0 1 5.813v2.75c0 1.138.924 2.062 2.063 2.062h17.875A2.063 2.063 0 0 0 23 8.562v-2.75a2.063 2.063 0 0 0-2.063-2.062H3.063ZM20.25 16.125V17.5h-11v-1.375h11Zm-17.188-2.75A2.063 2.063 0 0 0 1 15.438v2.75c0 1.138.924 2.062 2.063 2.062h17.875A2.063 2.063 0 0 0 23 18.187v-2.75a2.063 2.063 0 0 0-2.063-2.062H3.063Z"
      />
    ),
  },
  presentation: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M21.743 2.22H2.188C1.548 2.22 1 2.767 1 3.408c0 .675.547 1.222 1.188 1.222l.034 9.812c0 .672.55 1.222 1.222 1.222h7.334v1.328L7.902 19.87a.614.614 0 0 0-.001.867l.86.861c.24.239.63.239.869 0l2.37-2.37 2.334 2.368c.239.24.629.24.868 0l.86-.86a.614.614 0 0 0 0-.868l-2.84-2.874v-1.328h7.334c.672 0 1.222-.55 1.222-1.222V4.666A1.223 1.223 0 0 0 23 3.443c0-.676-.546-1.223-1.257-1.223Zm-2.41 11H4.667V4.665h14.666v8.555Z"
      />
    ),
  },
  map: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 1C5.924 1 1 5.924 1 12s4.924 11 11 11 11-4.924 11-11S18.076 1 12 1Zm8.86 12.184A8.938 8.938 0 0 1 12 20.938 8.936 8.936 0 0 1 3.48 9.293l.402.705a2.752 2.752 0 0 0 1.634 1.28l2.45.71c.777.21 1.245.884 1.245 1.653v1.715c0 .473.305.902.688 1.113.46.21.687.64.687 1.113v1.306c0 .683.692 1.177 1.35.988a2.057 2.057 0 0 0 1.409-1.41l.064-.231c.198-.73.658-1.276 1.28-1.633l.396-.228a2.055 2.055 0 0 0 1.04-1.792v-.352c0-.546-.22-1.074-.606-1.46l-.163-.164c-.387-.387-.915-.645-1.461-.645h-1.89c-.439 0-.912-.086-1.328-.322l-1.483-.85a.874.874 0 0 1 .043-1.534l.258-.125c.284-.142.61-.168.877-.065l1.035.331a.825.825 0 0 0 .941-.322.826.826 0 0 0-.052-.984l-.584-.696a1.372 1.372 0 0 1 .013-1.775l.675-.79a1.376 1.376 0 0 0 .15-1.577l-.102-.178a8.935 8.935 0 0 1 7.357 4.567l-1.102.44a1.38 1.38 0 0 0-.795 1.71l.726 2.179c.15.447.516.786.971.902l1.255.313Z"
        clipRule="evenodd"
      />
    ),
  },
  file: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M4 3.75A2.753 2.753 0 0 1 6.75 1h6.875v5.5c0 .76.614 1.375 1.375 1.375h5.5V20.25A2.753 2.753 0 0 1 17.75 23h-11A2.753 2.753 0 0 1 4 20.25V3.75ZM20.5 6.5H15V1l5.5 5.5Z"
      />
    ),
  },
  'convert-to-text': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m6.995 18-1.54-1.541L8.783 13.1H1v-2.202h7.783L5.455 7.541 6.995 6l5.995 6-5.995 6Zm6.105-.495v-2.202H23v2.202h-9.9Zm0-8.808V6.495H23v2.202h-9.9Zm3.3 4.404v-2.202H23v2.202h-6.6Z"
      />
    ),
  },
  'rotate-orientation': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M11.83 2.082c0-.44-.264-.833-.67-1.002a1.089 1.089 0 0 0-1.178.237L7.815 3.485c-.42.42-.42 1.11 0 1.53l2.167 2.168c.305.311.772.406 1.178.237.406-.17.67-.562.67-1.003V5.398H15a3.75 3.75 0 0 1 3.75 3.75v3.02h-1.17c-.44 0-.839.272-1.001.671-.163.4-.075.867.237 1.179l2.167 2.167c.42.42 1.11.42 1.53 0l2.167-2.167a1.084 1.084 0 0 0-.765-1.85H21v-3.02a6 6 0 0 0-6-6h-3.17V2.082Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M1 11a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V11Zm2.25 9.75v-8.5h8.5v8.5h-8.5Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  mgrs: {
    viewBox: '0 0 44 24',
    paths: (
      <path
        fill="currentColor"
        d="m4.292 6.206 1.213 4.808 1.38-4.808h3.068v12.798H7.685v-3.788l.106-5.986-1.68 5.555H4.89L3.387 9.467l.105 5.749v3.788H1.225V6.206h3.067ZM20.87 17.51c-.158.193-.375.39-.65.589-.275.2-.604.38-.985.545a6.993 6.993 0 0 1-1.265.387c-.47.1-.973.149-1.512.149-.727 0-1.383-.129-1.97-.387a4.157 4.157 0 0 1-1.502-1.116c-.416-.486-.739-1.081-.967-1.784-.223-.71-.334-1.512-.334-2.409v-1.74c0-.897.117-1.697.351-2.4.24-.71.569-1.31.985-1.802a4.28 4.28 0 0 1 1.477-1.125 4.416 4.416 0 0 1 1.846-.387c.72 0 1.347.09 1.88.273.54.181.994.445 1.363.79.37.34.656.757.861 1.249a5.66 5.66 0 0 1 .414 1.661h-2.409c-.082-.656-.281-1.148-.598-1.477-.31-.334-.794-.5-1.45-.5-.316 0-.61.081-.879.246-.27.158-.504.392-.703.703-.2.31-.358.697-.475 1.16a6.442 6.442 0 0 0-.176 1.591v1.758c.006 1.196.205 2.113.598 2.751.393.633.993.953 1.802.959a3.697 3.697 0 0 0 1.099-.168c.164-.052.308-.11.43-.175a.987.987 0 0 0 .29-.22l.01-2.32h-2.119v-1.847h4.58l.009 5.046Zm6.356-3.288h-1.873v4.782h-2.47V6.206h4.29c.709 0 1.35.085 1.925.255a4.158 4.158 0 0 1 1.468.73c.41.322.724.723.94 1.204.223.48.334 1.037.334 1.67 0 .457-.055.87-.166 1.24a3.314 3.314 0 0 1-1.196 1.74 4.716 4.716 0 0 1-.95.562l2.752 5.283v.114h-2.646l-2.408-4.782Zm-1.873-2.004h1.829c.697 0 1.233-.175 1.608-.527.381-.358.572-.844.572-1.46 0-.638-.185-1.133-.554-1.485-.37-.357-.914-.536-1.635-.536h-1.82v4.008Zm14.987 3.446a1.67 1.67 0 0 0-.123-.642 1.419 1.419 0 0 0-.404-.553 2.732 2.732 0 0 0-.747-.475 6.684 6.684 0 0 0-1.143-.405 11.005 11.005 0 0 1-1.6-.57 5.841 5.841 0 0 1-1.336-.827 3.888 3.888 0 0 1-.931-1.125c-.229-.428-.343-.92-.343-1.477 0-.54.114-1.028.343-1.468.228-.44.545-.814.949-1.125.404-.31.882-.548 1.433-.712a6.056 6.056 0 0 1 1.793-.255 5.49 5.49 0 0 1 1.828.29 4.24 4.24 0 0 1 1.433.818c.399.345.71.758.932 1.239a3.71 3.71 0 0 1 .334 1.582h-2.409a2.434 2.434 0 0 0-.158-.79 1.567 1.567 0 0 0-.404-.616 1.732 1.732 0 0 0-.668-.405 2.63 2.63 0 0 0-.932-.149c-.328 0-.621.041-.879.123a1.804 1.804 0 0 0-.642.334c-.175.14-.31.31-.404.51a1.511 1.511 0 0 0-.132.633c0 .24.059.457.176.65.123.194.299.37.527.528.229.152.504.293.827.422.328.129.697.249 1.107.36.586.17 1.125.378 1.617.624.493.246.915.54 1.266.88.358.333.633.717.827 1.15.199.428.298.906.298 1.433 0 .563-.114 1.064-.342 1.503a3.251 3.251 0 0 1-.932 1.108 4.349 4.349 0 0 1-1.424.686 6.742 6.742 0 0 1-1.802.228c-.404 0-.809-.038-1.213-.114a5.531 5.531 0 0 1-1.152-.334 5.11 5.11 0 0 1-1.02-.571 3.965 3.965 0 0 1-.826-.8 3.8 3.8 0 0 1-.545-1.038 4.041 4.041 0 0 1-.193-1.283h2.426c.012.387.08.718.202.993a1.8 1.8 0 0 0 .51.677c.223.176.486.305.791.387.31.082.65.123 1.02.123.328 0 .618-.038.87-.114.258-.076.475-.182.65-.317.176-.135.311-.296.405-.483.094-.194.14-.405.14-.633Z"
      />
    ),
  },
  'globe-outline': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M12 20.938c.318 0 1.16-.31 2.045-2.08.378-.76.705-1.685.946-2.733H9.009c.241 1.048.568 1.972.946 2.733.885 1.77 1.727 2.08 2.045 2.08Zm-3.33-6.875h6.66a19.888 19.888 0 0 0 0-4.126H8.67a19.874 19.874 0 0 0 0 4.126Zm.34-6.188h5.98c-.24-1.048-.567-1.972-.945-2.733-.885-1.77-1.727-2.08-2.045-2.08-.318 0-1.16.31-2.045 2.08-.378.76-.705 1.685-.946 2.733Zm8.39 2.063c.065.665.095 1.357.095 2.062 0 .705-.035 1.396-.095 2.063h3.296a9.06 9.06 0 0 0 .24-2.063c0-.709-.081-1.4-.24-2.063H17.4Zm2.527-2.063A8.973 8.973 0 0 0 15.7 3.862c.605 1.1 1.087 2.47 1.4 4.013h2.832-.004Zm-13.033 0c.314-1.543.795-2.909 1.401-4.013a8.973 8.973 0 0 0-4.228 4.013H6.9h-.005ZM3.303 9.938A9.062 9.062 0 0 0 3.063 12c0 .709.081 1.4.24 2.063H6.6A21.488 21.488 0 0 1 6.504 12c0-.705.035-1.396.095-2.063H3.303Zm12.397 10.2a8.973 8.973 0 0 0 4.228-4.013H17.1c-.313 1.543-.795 2.909-1.4 4.013Zm-7.4 0c-.605-1.1-1.087-2.47-1.4-4.013H4.068a8.973 8.973 0 0 0 4.228 4.013H8.3ZM12 23a11 11 0 1 1 0-22 11 11 0 0 1 0 22Z"
      />
    ),
  },
  'range-rings': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Zm0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 18.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0 1.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
          clipRule="evenodd"
        />
        <path fill="currentColor" d="M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
      </>
    ),
  },
  'mission-task': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.7 23V1H23v22h-2.3ZM15.1 6.035l-1.715-1.759 1.646-1.605 4.4 4.513-4.4 4.514-1.646-1.606 1.714-1.758H1v-2.3h14.1Zm0 10.223L13.384 14.5l1.646-1.605 4.4 4.513-4.4 4.514-1.646-1.606 1.714-1.758H1v-2.3h14.1Z"
        clipRule="evenodd"
      />
    ),
  },
  hillshade: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="m1 18.5 6-8.667 4.5 6.5H19L14 9.13l-2.5 3.575-1.25-1.787L14 5.5l9 13H1Z"
      />
    ),
  },
  'text-increase': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M22.707 6.207a1 1 0 0 1-1.414 0L18.5 3.414l-2.793 2.793a1 1 0 1 1-1.414-1.414l3.5-3.5a1 1 0 0 1 1.414 0l3.5 3.5a1 1 0 0 1 0 1.414Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M10.071 5.743A1.147 1.147 0 0 0 9 5c-.475 0-.904.296-1.071.743L3.064 18.714h-.921a1.142 1.142 0 1 0 0 2.286H5.57a1.142 1.142 0 1 0 0-2.286h-.064L6.15 17h5.7l.643 1.714h-.064a1.142 1.142 0 1 0 0 2.286h3.428a1.142 1.142 0 1 0 0-2.286h-.921L10.07 5.743Zm.922 8.971H7.007L9 9.396l1.993 5.318Z"
        />
      </>
    ),
  },
  'text-decrease': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M13.293 1.293a1 1 0 0 1 1.414 0L17.5 4.086l2.793-2.793a1 1 0 1 1 1.414 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-3.5-3.5a1 1 0 0 1 0-1.414Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M10.37 7.65C10.235 7.26 9.886 7 9.5 7s-.734.26-.87.65L4.676 19H3.93c-.515 0-.93.447-.93 1 0 .553.415 1 .929 1h2.785c.514 0 .929-.447.929-1 0-.553-.415-1-.929-1h-.052l.522-1.5h4.632l.522 1.5h-.052c-.514 0-.929.447-.929 1 0 .553.415 1 .929 1h2.785c.514 0 .929-.447.929-1 0-.553-.415-1-.929-1h-.748L10.37 7.65Zm.75 7.85H7.88l1.62-4.653 1.62 4.653Z"
        />
      </>
    ),
  },
  'copy-xplan': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.688 1H17.5v4.125c0 .756.619 1.375 1.414 1.375H23v8.938a2.062 2.062 0 0 1-2.063 2.062h-8.25a2.062 2.062 0 0 1-2.062-2.063V3.063c0-1.14.923-2.063 2.063-2.063ZM23 5.125h-4.125V1L23 5.125ZM9.25 6.5v9.625a2.753 2.753 0 0 0 2.75 2.75h1.375v2.063A2.062 2.062 0 0 1 11.312 23h-8.25A2.062 2.062 0 0 1 1 20.937V8.563C1 7.423 1.923 6.5 3.063 6.5H9.25Zm5.528 2.668c-1.535 0-2.778 1.343-2.778 3 0 1.658 1.243 3 2.778 3h1.11c.308 0 .556-.268.556-.6 0-.332-.248-.6-.555-.6h-1.111c-.92 0-1.667-.806-1.667-1.8 0-.993.747-1.8 1.667-1.8h1.11c.308 0 .556-.268.556-.6 0-.332-.248-.6-.555-.6h-1.111Zm4.444 6c1.535 0 2.778-1.342 2.778-3 0-1.657-1.243-3-2.778-3h-1.11c-.308 0-.556.268-.556.6 0 .332.248.6.555.6h1.111c.92 0 1.667.806 1.667 1.8s-.747 1.8-1.667 1.8h-1.11c-.308 0-.556.268-.556.6 0 .332.248.6.555.6h1.111Zm-.555-3.6h-3.334c-.307 0-.555.268-.555.6 0 .332.248.6.555.6h3.334c.307 0 .555-.268.555-.6 0-.332-.248-.6-.555-.6Z"
        clipRule="evenodd"
      />
    ),
  },
  overlay: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.623 8.418a1.25 1.25 0 0 0 0 2.164l2.389 1.38-2.389 1.422c-.833.496-.833 1.736 0 2.232l8.752 5.211c.387.23.864.23 1.25 0l8.752-5.212c.833-.495.833-1.735 0-2.23l-2.388-1.423 2.388-1.38a1.25 1.25 0 0 0 0-2.164L12.625 3.36a1.25 1.25 0 0 0-1.25 0L2.623 8.418Zm4.418 4.717 4.334 2.504a1.25 1.25 0 0 0 1.25 0l4.334-2.505 2.293 1.366L12 18.819 4.748 14.5l2.293-1.365Z"
        clipRule="evenodd"
      />
    ),
  },
  'overlay-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.577 6.82a1.152 1.152 0 0 0 0 1.996l2.206 1.273-2.206 1.312c-.77.458-.77 1.6 0 2.058l8.085 4.808c.045.027.09.05.138.07v-1.989a3.3 3.3 0 0 1 .006-.192L3.54 12.43l2.118-1.26 4.004 2.31c.358.207.798.207 1.155 0l.816-.47c.239-3.015 2.86-5.26 5.867-5.26.677 0 1.335.114 1.951.325a1.148 1.148 0 0 0-.548-1.256l-8.085-4.664a1.156 1.156 0 0 0-1.156 0L1.577 6.819Zm15.59 2.997Zm-4.82 5.601c.2-.141.448-.225.716-.225h.605-.605c-.268 0-.516.084-.717.225Zm8.885-.168h.59c.65 0 1.178.504 1.178 1.125v4.5c0 .621-.528 1.125-1.179 1.125H13.18c-.652 0-1.18-.504-1.18-1.125v-4.5c0-.621.528-1.125 1.179-1.125h.589v-1.688c0-1.964 1.674-3.562 3.732-3.562 2.058 0 3.732 1.598 3.732 3.563v1.687Zm-5.5-1.688v1.688h3.536v-1.688c0-.93-.793-1.687-1.768-1.687s-1.768.757-1.768 1.688Z"
        clipRule="evenodd"
      />
    ),
  },
  'aspect-ratio': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M14 17h5v-5h-2v3h-3v2Zm-9-5h2V9h3V7H5v5Zm-1 8c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm0-2h16V6H4v12Z"
      />
    ),
  },
  'aspect-ratio-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M16.493 6.957a4.421 4.421 0 0 1 4.415 4.416v2.092h.697c.77 0 1.395.624 1.395 1.394v5.577c0 .77-.625 1.395-1.395 1.395H11.38c-.77 0-1.395-.625-1.395-1.395V14.86c0-.77.625-1.394 1.395-1.394h.697v-2.092a4.422 4.422 0 0 1 4.416-4.416ZM20.522 2c.596 0 1.106.212 1.53.637.425.424.638.936.638 1.532v6.223a6.273 6.273 0 0 0-2.169-3.827V4.17H3.17v13.015h4.957v2.168H3.169a2.09 2.09 0 0 1-1.532-.636A2.09 2.09 0 0 1 1 17.184V4.169c0-.596.212-1.108.637-1.532A2.09 2.09 0 0 1 3.169 2H20.52Zm-4.029 7.281a2.094 2.094 0 0 0-2.092 2.092v2.092h4.183v-2.092a2.094 2.094 0 0 0-2.09-2.092ZM9.676 7.423H6.422v3.253h-2.17V5.254h5.424v2.169Z"
      />
    ),
  },
  'aspect-ratio-unlocked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M16.5 7c1.669 0 3.105.987 3.775 2.41a.93.93 0 0 1-.464 1.25.898.898 0 0 1-1.213-.446A2.32 2.32 0 0 0 16.5 8.875a2.332 2.332 0 0 0-2.321 2.344v1.406h6.964c1.024 0 1.857.84 1.857 1.875v5.625A1.868 1.868 0 0 1 21.143 22h-9.286A1.867 1.867 0 0 1 10 20.125V14.5c0-1.034.832-1.875 1.857-1.875h.464v-1.406C12.321 8.889 14.193 7 16.5 7Z"
        />
        <path
          fill="currentColor"
          d="M20.521 2c.597 0 1.107.212 1.532.637.424.424.637.936.637 1.532v6.223a6.273 6.273 0 0 0-2.169-3.827V4.17H3.17v13.015h4.957v2.168H3.169a2.09 2.09 0 0 1-1.532-.636A2.09 2.09 0 0 1 1 17.184V4.169c0-.596.212-1.108.637-1.532A2.09 2.09 0 0 1 3.169 2H20.52Z"
        />
        <path fill="currentColor" d="M9.676 7.423H6.422v3.253h-2.17V5.254h5.424v2.169Z" />
      </>
    ),
  },
  'shrink-to-fit': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.655 5.433a1 1 0 0 1-1.31 0L8.831 3.256c-.7-.606-.27-1.756.655-1.756h5.028c.926 0 1.354 1.15.655 1.756l-2.514 2.177ZM2 7.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-1Zm0 8a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-1Zm.5-4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-19Zm10.155 7.567a1 1 0 0 0-1.31 0l-2.514 2.177c-.7.606-.27 1.756.655 1.756h5.028c.926 0 1.354-1.15.655-1.756l-2.514-2.177Z"
        clipRule="evenodd"
      />
    ),
  },
  'card-text': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 5.5a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5v-1Zm0 6a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5v-1Zm.5 5.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-16Z"
        clipRule="evenodd"
      />
    ),
  },
  'card-icon': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M9.25 5.026C9.25 3.556 10.496 1 12 1c1.547 0 2.75 2.557 2.75 4.026v2.849l7.64 5.092c.382.253.61.683.61 1.143v2.436c0 .469-.46.8-.907.653L14.75 14.75v3.438l2.475 1.856a.692.692 0 0 1 .275.55v1.804a.6.6 0 0 1-.602.602.745.745 0 0 1-.167-.021L12 21.625l-4.73 1.354a.56.56 0 0 1-.168.021.6.6 0 0 1-.602-.602v-1.804c0-.215.103-.421.275-.55l2.475-1.857V14.75L1.907 17.2A.69.69 0 0 1 1 16.545V14.11c0-.46.228-.89.61-1.143l7.64-5.092V5.026Z"
      />
    ),
  },
  'card-icon-and-text': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M12 20H3.2C1.985 20 1 18.975 1 17.707V6.293c-.001-.301.055-.6.165-.878.11-.278.272-.53.476-.744.205-.213.448-.382.715-.497C2.624 4.059 2.91 4 3.2 4H12v16Zm11-2.286h-8.8V20h7.703a1.093 1.093 0 0 0 .777-.335 1.146 1.146 0 0 0 .32-.808v-1.143Zm0-4.571h-8.8v2.286H23v-2.286Zm0-8C23 4.512 22.502 4 21.903 4H14.2v2.286H23V5.143Zm0 3.428h-8.8v2.286H23V8.571Z"
      />
    ),
  },
  'trash-caution': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M13.29 2.26h4.726a.63.63 0 0 1 .63.63v1.261a.63.63 0 0 1-.63.63H1.63a.63.63 0 0 1-.63-.63v-1.26a.63.63 0 0 1 .63-.63h4.727l.37-.737A.934.934 0 0 1 7.57 1h4.502a.945.945 0 0 1 .847.524l.37.736ZM3.688 20.654a1.89 1.89 0 0 1-.593-1.26L2.26 6.042h10.005a9.628 9.628 0 0 0-6.682 9.166c0 2.25.772 4.32 2.065 5.959H4.982a1.89 1.89 0 0 1-1.294-.513Z"
        />
        <path
          fill="currentColor"
          d="M15.208 7.417a7.791 7.791 0 0 0-7.791 7.791A7.791 7.791 0 0 0 15.208 23 7.791 7.791 0 0 0 23 15.208a7.791 7.791 0 0 0-7.792-7.791Zm-.73 4.626a.73.73 0 0 1 1.46 0v3.896a.73.73 0 0 1-1.46 0v-3.896Zm.73 7.548a.957.957 0 1 1 0-1.914.957.957 0 0 1 0 1.914Z"
        />
      </>
    ),
  },
  'check-sync': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="m1.313 12.49 6.959 6.959a1.07 1.07 0 0 0 1.514 0l1.64-1.64a2.621 2.621 0 0 1-.29-2.265 5.37 5.37 0 0 1 5.092-3.67h.506c.12-.404.34-.786.66-1.105a2.618 2.618 0 0 1 1.84-.769l2.862-2.862a1.07 1.07 0 0 0 0-1.513L20.582 4.11a1.07 1.07 0 0 0-1.514 0L9.028 14.15 4.342 9.462a1.07 1.07 0 0 0-1.514 0l-1.514 1.514a1.07 1.07 0 0 0 0 1.514Z"
        />
        <path
          fill="currentColor"
          d="M13.427 16.969a.626.626 0 0 1-.395-.791 3.37 3.37 0 0 1 3.196-2.303h3.388l-.808-.807a.626.626 0 0 1 .884-.885l1.875 1.875a.626.626 0 0 1 0 .885l-1.875 1.875a.626.626 0 0 1-.884-.885l.808-.808h-3.388a2.12 2.12 0 0 0-2.01 1.45.626.626 0 0 1-.791.394Z"
        />
        <path
          fill="currentColor"
          d="M22.573 17.031c.326.11.504.463.395.791h.002a3.37 3.37 0 0 1-3.196 2.303h-3.388l.808.807a.626.626 0 0 1-.884.885l-1.875-1.875a.626.626 0 0 1 0-.885l1.875-1.875a.626.626 0 0 1 .884.885l-.808.808h3.388c.912 0 1.721-.584 2.008-1.45a.626.626 0 0 1 .791-.394Z"
        />
      </>
    ),
  },
  briefs: {
    viewBox: '0 0 56 56',
    paths: (
      <>
        <path
          fill="#3983B1"
          fillRule="evenodd"
          d="m5.267 11.817-1.128-.063L1 36.077l.952.376C11.397 40.188 18.45 48.8 20.756 52.591l.368.605h13.788l.332-.605c2.307-3.792 9.359-12.403 18.803-16.138l.953-.376-2.979-23.085-.143-1.26-1.159.086c-14.119.962-32.394.722-45.452-.001Zm44.463 2.812c-13.658.857-30.786.647-43.459-.013L3.846 33.408s7.27 0 12.198 3.862c5.088 4.224 6.65 8.734 6.91 13.184h10.093c.258-4.45 2.294-8.96 7.382-13.184 2.571-2.135 6.492-3.862 11.725-3.862L49.73 14.629Z"
          clipRule="evenodd"
        />
        <path
          fill="#49A2DA"
          d="M28 15.193c7.454.02 15.012-.143 21.73-.564l2.424 18.779c-5.233 0-9.154 1.727-11.725 3.862-5.088 4.224-7.124 8.734-7.382 13.184H28V15.193Z"
        />
        <path
          fill="#78BAE3"
          d="M49.73 14.63c-13.658.856-30.786.646-43.459-.014L3.846 33.408s6.416 0 11.278 3.201l.13.015.1.14c.234.16.465.33.69.506 5.088 4.224 6.65 8.734 6.91 13.184H28V15.193c7.454.02 15.012-.143 21.73-.564Z"
        />
      </>
    ),
  },
  'ce-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M21 6c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2ZM1 11.5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2Zm15.45-3.963.6.8-.883.663h-.964l-.253-.338 1.5-1.125ZM13.954 9A3.489 3.489 0 0 0 11.5 7.997c-.262 0-.519.034-.762.09l-1.275-2.73C9.793 5 10 4.524 10 4c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2a.349.349 0 0 0 .05-.005.405.405 0 0 1 .05-.004l1.281 2.743A3.474 3.474 0 0 0 8 11.5c0 .955.381 1.82 1 2.45V12.5A3.5 3.5 0 0 1 12.5 9h1.454ZM7.25 12h-1.5v-1h1.5v1Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'lists-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M2.5 3h13A1.5 1.5 0 0 1 17 4.5V9h-2V7h-5v3.05c-.619.632-1 1.496-1 2.45V17H2.5A1.5 1.5 0 0 1 1 15.5v-11A1.5 1.5 0 0 1 2.5 3ZM3 15h5V7H3v8Z"
          clipRule="evenodd"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'timeline-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M1 5.125C1 4.228 1.756 3.5 2.688 3.5h14.624c.932 0 1.688.728 1.688 1.625v2.167c0 .897-.756 1.625-1.688 1.625H2.688C1.756 8.917 1 8.189 1 7.292V5.125ZM12.25 6.75h4.5V5.667h-4.5V6.75Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          d="M9 14.333H7.75V13.25H9v-.75c0-.504.107-.984.299-1.417H2.688c-.932 0-1.688.728-1.688 1.625v2.167c0 .897.756 1.625 1.688 1.625H9v-2.167Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'c2-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M9 2a1.5 1.5 0 0 0-1.5 1.5v2A1.5 1.5 0 0 0 9 7h.25v1.25H4.5A1.75 1.75 0 0 0 2.75 10v1H2.5A1.5 1.5 0 0 0 1 12.5v2A1.5 1.5 0 0 0 2.5 16h2A1.5 1.5 0 0 0 6 14.5v-2A1.5 1.5 0 0 0 4.5 11h-.25v-1a.25.25 0 0 1 .25-.25h4.75V11H9a1.5 1.5 0 0 0-1.5 1.5v2A1.5 1.5 0 0 0 9 16v-3.5A3.5 3.5 0 0 1 12.5 9h4.436a1.749 1.749 0 0 0-1.436-.75h-4.75V7H11a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 11 2H9Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'whiteboards-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.056 4.143C2.056 2.96 3.002 2 4.166 2h12.667c1.165 0 2.111.96 2.111 2.143V9h-2.11V4.143H4.166v9.643h-2.11V4.143ZM9 12.714h-.556c-.583 0-1.055.48-1.055 1.072v1.071H2.056c-.584 0-1.056.479-1.056 1.072C1 16.52 1.472 17 2.056 17H9v-4.286Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'orders-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M4.75 2C3.784 2 3 2.778 3 3.739V17.26c0 .961.784 1.74 1.75 1.74H9v-1.546H4.75a.194.194 0 0 1-.194-.193V3.74c0-.107.087-.194.194-.194h6.028v4.057c0 .32.26.58.583.58h4.083V9H17v-.87a1.73 1.73 0 0 0-.513-1.23l-4.419-4.39A1.756 1.756 0 0 0 10.831 2H4.75Z"
        />
        <path
          fill="currentColor"
          d="M9.627 10.5H6.5a.388.388 0 0 0-.389.386v.773c0 .213.174.386.389.386h2.53a3.48 3.48 0 0 1 .597-1.545ZM9 13.59H6.5a.388.388 0 0 0-.389.387v.773c0 .213.174.386.389.386H9v-1.545Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'presentations-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.026 2h16.889C19.528 2 20 2.476 20 3.063a1.06 1.06 0 0 1-1.056 1.063V9h-2.11V4.125H4.166v7.437h4.96A3.503 3.503 0 0 0 9 12.5v1.187H3.111c-.58 0-1.055-.478-1.055-1.063l-.03-8.529C1.473 4.095 1 3.62 1 3.033 1 2.476 1.473 2 2.026 2ZM9 15.288l-2.04 2.054a.537.537 0 0 0 0 .754l.743.748a.529.529 0 0 0 .75 0l.547-.55v-3.006Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'maps-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1 10.5A8.502 8.502 0 0 1 17.868 9h-3.734l-.069-.207a1.066 1.066 0 0 1 .615-1.321l.85-.34a6.904 6.904 0 0 0-5.684-3.53l.079.139c.223.39.176.877-.116 1.218l-.521.61a1.06 1.06 0 0 0-.01 1.372l.451.538c.18.215.196.524.04.76a.638.638 0 0 1-.727.249l-.8-.256a.853.853 0 0 0-.678.05l-.199.096a.676.676 0 0 0-.033 1.186l1.145.657c.322.183.688.25 1.026.25h.145A3.484 3.484 0 0 0 9 12.5v4.085a.805.805 0 0 1-.592-.763v-1.009c0-.365-.176-.697-.532-.86-.295-.163-.53-.495-.53-.86v-1.325c0-.594-.363-1.115-.964-1.278L4.49 9.942a2.126 2.126 0 0 1-1.263-.99l-.311-.544A6.905 6.905 0 0 0 9 17.388v1.598A8.5 8.5 0 0 1 1 10.5Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'plan-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M11.094 5.333h7.125c.983 0 1.781.784 1.781 1.75V9h-7.5A3.5 3.5 0 0 0 9 12.5V17H2.781C1.797 17 1 16.216 1 15.25V4.75C1 3.783 1.797 3 2.781 3H8.72l2.375 2.333Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'section-template': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M20 9V7.282C20 6.1 18.935 5.14 17.625 5.14h-5.544a2.512 2.512 0 0 1-1.681-.627l-.984-.887A2.513 2.513 0 0 0 7.736 3H3.374C2.065 3 1 3.96 1 5.143v10.714C1 17.04 2.065 18 3.375 18H9v-5.5a3.501 3.501 0 0 1 2.688-3.405V7.82c0-.294.267-.535.593-.535h4.75c.327 0 .594.24.594.535V9H20Z"
        />
        <path
          fill={themeColors.template}
          fillRule="evenodd"
          d="M11 12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-9Zm7.286 2.357v6.674h-2.572v-6.674h-3V13h8.679v1.857h-3.107Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  template: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0 2.75A2.75 2.75 0 0 1 2.75 0h16.5A2.75 2.75 0 0 1 22 2.75v16.5A2.75 2.75 0 0 1 19.25 22H2.75A2.75 2.75 0 0 1 0 19.25V2.75ZM13 7v12H9V7H3V4h16.054v3H13Z"
        clipRule="evenodd"
      />
    ),
  },
  scale: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M21 18c.417 0 .717-.183.9-.55.183-.367.15-.717-.1-1.05l-4-5.325a.95.95 0 0 0-.8-.4.95.95 0 0 0-.8.4L12.5 16H5l5-6.65 2.5 3.3L13.75 11 10.8 7.075a.95.95 0 0 0-.8-.4.95.95 0 0 0-.8.4l-7 9.325c-.25.333-.283.683-.1 1.05.183.367.483.55.9.55h18Zm-2-2h-4l2-2.675L19 16Z"
      />
    ),
  },
  'line-break': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M15.455 7H2.665a.654.654 0 0 0-.47.201.7.7 0 0 0-.195.487v1.375a.7.7 0 0 0 .195.486.654.654 0 0 0 .47.201h12.79a.654.654 0 0 0 .47-.201.7.7 0 0 0 .195-.486V7.687a.7.7 0 0 0-.195-.486.654.654 0 0 0-.47-.201Zm-7.522 6.5H2.688a.687.687 0 0 0-.688.688v1.374a.687.687 0 0 0 .688.688h5.245a.687.687 0 0 0 .687-.688v-1.374a.687.687 0 0 0-.687-.688ZM19.25 8.375c0-.76.614-1.375 1.375-1.375.76 0 1.375.614 1.375 1.375V13a4.126 4.126 0 0 1-4.125 4.125h-2.223l1.154 1.154a1.377 1.377 0 0 1-1.947 1.946l-3.5-3.5a1.377 1.377 0 0 1 0-1.946l3.5-3.5a1.377 1.377 0 0 1 1.947 1.946l-1.154 1.15h2.223c.76 0 1.375-.614 1.375-1.375V8.375Z"
      />
    ),
  },
  'new-slide-2': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M11.875 14.375L14.0572 14.3697C14.3017 14.3697 14.4999 14.1715 14.5 13.9269L14.5 13.0625C14.5 12.818 14.3018 12.6198 14.0572 12.6197L11.875 12.625L11.8697 10.4428C11.8697 10.1983 11.6715 10.0001 11.4269 10L10.5625 10C10.318 10 10.1198 10.1982 10.1197 10.4428L10.125 12.625L7.94283 12.6197C7.69832 12.6197 7.50011 12.8179 7.50001 13.0625L7.5 13.9269C7.5 14.1714 7.69831 14.3697 7.94282 14.3697L10.125 14.375L10.1197 16.5572C10.1197 16.8017 10.318 17 10.5625 17L11.4269 17C11.6714 17 11.8696 16.8018 11.8697 16.5572L11.875 14.375Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 2.5C5.89543 2.5 5 3.39543 5 4.5V6H3.5C2.39543 6 1.5 6.89543 1.5 8V19C1.5 20.1046 2.39543 21 3.5 21H17.5C18.6046 21 19.5 20.1046 19.5 19V17.5H21C22.1046 17.5 23 16.6046 23 15.5V4.5C23 3.39543 22.1046 2.5 21 2.5H7ZM17.5 6H7V4.5H21V15.5H19.5V8C19.5 6.89543 18.6046 6 17.5 6ZM3.5 8H17.5V19H3.5L3.5 8Z"
        />
      </>
    ),
  },
  'add-image': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8532 4H4.97071C3.81464 4 2.85352 4.96116 2.85352 6.14709V16.8825C2.85352 18.0684 3.81467 19.0296 4.97041 19.0296H13V16.8825H5.60511C5.40312 16.8825 5.2183 16.7692 5.12671 16.589C5.03512 16.4089 5.0524 16.1928 5.17146 16.0294L7.51984 12.8088C7.62102 12.6689 7.78205 12.5883 7.95315 12.5883C8.12424 12.5883 8.28581 12.6702 8.38692 12.8089L9.4759 14.3021L12.6059 9.63556C12.7069 9.45829 12.8747 9.36771 13.0525 9.36771C13.2303 9.36771 13.3997 9.45735 13.499 9.60674L15.1142 12.0296H20V6.14709C20.0003 4.96116 19.0677 4 17.8532 4ZM6.58103 6.14709C7.47039 6.14709 8.19134 6.86804 8.19134 7.7574C8.19134 8.64676 7.50025 9.36771 6.58103 9.36771C5.66181 9.36771 4.97071 8.64676 4.97071 7.7574C4.97071 6.86804 5.72152 6.14709 6.58103 6.14709Z"
        />
        <path
          d="M22.4939 18.9831L20 18.9892L19.994 21.4831C19.9939 21.7626 19.7673 21.9892 19.4879 21.9892L18.5 21.9892C18.2206 21.9892 17.9939 21.7625 17.9939 21.4831L18 18.9892L15.5061 18.9831C15.2266 18.9831 15 18.7564 15 18.477L15 17.4892C15.0001 17.2096 15.2267 16.9831 15.5061 16.9831L18 16.9892L17.994 14.4953C17.9941 14.2157 18.2206 13.9892 18.5 13.9892L19.4879 13.9892C19.7675 13.9893 19.994 14.2158 19.994 14.4953L20 16.9892L22.4939 16.9831C22.7735 16.9832 23 17.2097 23 17.4892L23 18.477C22.9999 18.7566 22.7733 18.9831 22.4939 18.9831Z"
          fill="currentColor"
        />
      </>
    ),
  },
  group: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M4.3 10.893a2.21 2.21 0 0 0 2.2-2.214 2.21 2.21 0 0 0-2.2-2.215A2.21 2.21 0 0 0 2.1 8.68a2.21 2.21 0 0 0 2.2 2.214Zm15.4 0a2.21 2.21 0 0 0 2.2-2.214 2.21 2.21 0 0 0-2.2-2.215 2.21 2.21 0 0 0-2.2 2.215 2.21 2.21 0 0 0 2.2 2.214ZM20.8 12h-2.2c-.605 0-1.152.246-1.55.643a5.061 5.061 0 0 1 2.581 3.786H21.9c.608 0 1.1-.495 1.1-1.108v-1.107A2.21 2.21 0 0 0 20.8 12ZM12 12c2.128 0 3.85-1.733 3.85-3.875S14.128 4.25 12 4.25 8.15 5.983 8.15 8.125 9.872 12 12 12Zm2.64 1.107h-.285a5.386 5.386 0 0 1-2.355.554 5.398 5.398 0 0 1-2.355-.554H9.36c-2.186 0-3.96 1.785-3.96 3.986v.996c0 .917.74 1.661 1.65 1.661h9.9c.91 0 1.65-.744 1.65-1.66v-.997c0-2.2-1.774-3.986-3.96-3.986Zm-7.69-.463A2.186 2.186 0 0 0 5.4 12H3.2A2.21 2.21 0 0 0 1 14.214v1.107c0 .613.492 1.108 1.1 1.108h2.265a5.074 5.074 0 0 1 2.585-3.785Z"
      />
    ),
  },
  'x-plan': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <circle cx="12" cy="12" r="11" fill="currentColor" />
        <path
          fill="#fff"
          d="M4.474 12c0-2.24 1.87-4.053 4.181-4.053h1.673c.462 0 .836.363.836.81 0 .45-.374.811-.836.811H8.655c-1.385 0-2.509 1.09-2.509 2.432 0 1.342 1.124 2.432 2.509 2.432h1.673c.462 0 .836.362.836.81 0 .448-.374.81-.836.81H8.655c-2.31 0-4.181-1.813-4.181-4.052Zm15.052 0c0 2.24-1.87 4.053-4.181 4.053h-1.673a.823.823 0 0 1-.836-.81c0-.45.374-.811.836-.811h1.673c1.385 0 2.509-1.09 2.509-2.432 0-1.342-1.124-2.432-2.509-2.432h-1.673a.823.823 0 0 1-.836-.81c0-.448.374-.81.836-.81h1.673c2.31 0 4.181 1.813 4.181 4.052Zm-10.035-.81h5.018c.462 0 .836.362.836.81 0 .448-.374.81-.836.81H9.49a.823.823 0 0 1-.836-.81c0-.448.374-.81.836-.81Z"
        />
      </>
    ),
  },
  'circle-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M10.516 9.766v1.547h3.093V9.766c0-.853-.694-1.547-1.546-1.547-.853 0-1.547.694-1.547 1.547Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm3.328-11.687h.516c.57 0 1.031.461 1.031 1.03v4.126a1.03 1.03 0 0 1-1.031 1.031H8.28a1.03 1.03 0 0 1-1.031-1.031v-4.125c0-.57.462-1.031 1.031-1.031h.516V9.766A3.27 3.27 0 0 1 12.062 6.5a3.27 3.27 0 0 1 3.266 3.266v1.547Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'section-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M22.044 10.059V8.257c0-1.451-1.18-2.63-2.631-2.63h-6.14a2.631 2.631 0 0 1-1.862-.77L10.32 3.77A2.631 2.631 0 0 0 8.46 3H3.63C2.18 3 1 4.18 1 5.63v13.153c0 1.45 1.18 2.63 2.63 2.63h8.19a7.628 7.628 0 0 1-2.211-5.38 7.643 7.643 0 0 1 3.228-6.245v-.87a.66.66 0 0 1 .658-.657h5.26a.66.66 0 0 1 .61.412 7.63 7.63 0 0 1 2.679 1.386Z"
        />
        <path fill="currentColor" d="M16.486 14.867v.807H18.1v-.807a.808.808 0 0 0-1.614 0Z" />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 21.772a5.74 5.74 0 1 0 0-11.479 5.74 5.74 0 0 0 0 11.479Zm1.737-6.098h.27c.296 0 .537.24.537.538v2.152c0 .297-.24.538-.538.538h-3.945a.538.538 0 0 1-.538-.538v-2.152c0-.297.24-.538.538-.538h.269v-.807c0-.94.764-1.704 1.704-1.704.939 0 1.703.764 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'c2-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M10.353 3c-.968 0-1.754.785-1.754 1.754v2.338c0 .968.786 1.753 1.754 1.753h.292v1.462H5.092a2.047 2.047 0 0 0-2.046 2.046v1.169h-.292c-.969 0-1.754.785-1.754 1.753v2.338c0 .969.785 1.754 1.754 1.754h2.338c.968 0 1.753-.785 1.753-1.754v-2.338c0-.968-.785-1.753-1.753-1.753H4.8v-1.17c0-.16.131-.292.292-.292h4.84a7.672 7.672 0 0 1 4.511-4.911l.001-.057V4.754c0-.969-.785-1.754-1.753-1.754h-2.338Z"
        />
        <path
          fill="currentColor"
          d="M11.557 19.367a7.624 7.624 0 0 1-1.926-5.69 1.755 1.755 0 0 0-1.032 1.598v2.338c0 .969.786 1.754 1.754 1.754h1.204Zm4.929-6.267v.807h1.615V13.1a.808.808 0 0 0-1.614 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 20.005a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478Zm1.737-6.098h.27c.296 0 .537.241.537.538v2.152a.538.538 0 0 1-.538.538h-3.945a.538.538 0 0 1-.538-.538v-2.152c0-.297.24-.538.538-.538h.269V13.1c0-.94.764-1.704 1.704-1.704.939 0 1.703.765 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'ce-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M17.874 7.616c1.27.1 2.453.511 3.473 1.156a2.1 2.1 0 0 0 .697-1.563 2.107 2.107 0 0 0-2.105-2.105 2.106 2.106 0 0 0-2.065 2.512Zm-5.466 1.711a3.572 3.572 0 0 0-1.162.078L9.903 6.531c.349-.374.566-.874.566-1.427A2.105 2.105 0 0 0 8.365 3c-1.16 0-2.104.944-2.104 2.104 0 1.161.944 2.105 2.104 2.105.018 0 .036-.003.053-.005a.296.296 0 0 1 .052-.005l1.349 2.887a3.656 3.656 0 0 0-1.454 2.91c0 1.108.488 2.1 1.262 2.775a7.637 7.637 0 0 1 2.78-6.444ZM1 12.996c0-1.161.944-2.105 2.104-2.105 1.161 0 2.105.944 2.105 2.105 0 1.16-.944 2.104-2.105 2.104A2.106 2.106 0 0 1 1 12.996Zm6.576.526H5.998V12.47h1.578v1.052Zm8.91.556v.807h1.615v-.807a.808.808 0 0 0-1.614 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 20.983a5.74 5.74 0 1 0 0-11.479 5.74 5.74 0 0 0 0 11.479Zm1.737-6.098h.27c.296 0 .537.24.537.538v2.152a.538.538 0 0 1-.538.538h-3.945a.538.538 0 0 1-.538-.538v-2.152c0-.297.24-.538.538-.538h.269v-.807c0-.94.764-1.704 1.704-1.704.939 0 1.703.764 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'map-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M1 11.522C1 5.71 5.71 1 11.522 1c5.389 0 9.83 4.05 10.448 9.272a7.62 7.62 0 0 0-4.817-1.62c.104-.385.383-.72.78-.879l1.054-.421a8.547 8.547 0 0 0-7.037-4.369l.098.171a1.316 1.316 0 0 1-.144 1.509l-.645.755a1.313 1.313 0 0 0-.013 1.698l.56.666a.79.79 0 0 1 .049.94.79.79 0 0 1-.9.31l-.991-.317a1.056 1.056 0 0 0-.838.061l-.247.12a.836.836 0 0 0-.041 1.467l1.418.814c.335.19.707.278 1.066.301a7.617 7.617 0 0 0-1.7 4.376 1.188 1.188 0 0 0-.11-.058c-.366-.201-.658-.612-.658-1.064v-1.64c0-.736-.448-1.381-1.192-1.583l-2.342-.678a2.632 2.632 0 0 1-1.563-1.225l-.385-.674a8.548 8.548 0 0 0-.4 2.59 8.55 8.55 0 0 0 7.597 8.496c.42.757.966 1.434 1.608 2.005-.217.014-.435.02-.655.02C5.71 22.044 1 17.334 1 11.523Z"
        />
        <path fill="currentColor" d="M16.486 15.139v.807h1.615v-.807a.808.808 0 0 0-1.614 0Z" />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 22.044a5.74 5.74 0 1 0 0-11.479 5.74 5.74 0 0 0 0 11.479Zm1.737-6.098h.27c.296 0 .537.24.537.538v2.152a.538.538 0 0 1-.538.538h-3.945a.538.538 0 0 1-.538-.538v-2.152c0-.297.24-.538.538-.538h.269v-.807c0-.94.764-1.704 1.704-1.704.939 0 1.703.764 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'list-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.875 3h16.25C20.16 3 21 3.863 21 4.929v4.826a7.983 7.983 0 0 0-2.5-1.357v-.255h-.987a8.042 8.042 0 0 0-3.026 0H12.25v.789a8.036 8.036 0 0 0-2.5 2.074V8.143H3.5v10.286h4.875A7.983 7.983 0 0 0 9.755 21h-6.88C1.839 21 1 20.137 1 19.071V4.93C1 3.863 1.84 3 2.875 3Z"
        />
        <path fill="currentColor" d="M15.19 14.781v.844h1.688v-.844a.845.845 0 0 0-1.687 0Z" />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M16 22a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm1.816-6.375h.281c.31 0 .563.252.563.563v2.25c0 .31-.253.562-.563.562h-4.125a.563.563 0 0 1-.563-.563v-2.25c0-.31.252-.562.563-.562h.281v-.844c0-.982.8-1.781 1.782-1.781s1.78.8 1.78 1.781v.844Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'orders-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M4.25 1A2.25 2.25 0 0 0 2 3.25v17.5A2.25 2.25 0 0 0 4.25 23h6.458a8.036 8.036 0 0 1-1.638-2H4.25a.25.25 0 0 1-.25-.25V3.25A.25.25 0 0 1 4.25 3H12v5.25c0 .414.336.75.75.75H18v.252a7.95 7.95 0 0 1 2 .818V8.932a2.25 2.25 0 0 0-.659-1.591l-5.682-5.682A2.25 2.25 0 0 0 12.068 1H4.25Z"
        />
        <path
          fill="currentColor"
          d="M9.755 12H6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.082a7.993 7.993 0 0 1 1.173-2Zm-1.693 4H6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.562a8.079 8.079 0 0 1 0-2Zm7.128-.219v.844h1.688v-.844a.845.845 0 0 0-1.688 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M16 23a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm1.815-6.375h.282c.31 0 .562.252.562.563v2.25c0 .31-.252.562-.562.562h-4.125a.563.563 0 0 1-.563-.563v-2.25c0-.31.252-.562.563-.562h.28v-.844c0-.982.8-1.781 1.782-1.781s1.781.8 1.781 1.781v.844Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'presentation-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.136 3h18.706c.679 0 1.202.524 1.202 1.17a1.17 1.17 0 0 1-1.17 1.17v4.094a7.6 7.6 0 0 0-2.338-.8V5.34H4.507v8.183h5.576a7.622 7.622 0 0 0-.468 2.338H3.338a1.173 1.173 0 0 1-1.169-1.17l-.033-9.384C1.524 5.306 1 4.782 1 4.136 1 3.524 1.524 3 2.136 3Zm7.627 14.72-2.161 2.162a.588.588 0 0 0-.001.83l.823.823a.588.588 0 0 0 .83 0l1.434-1.433a7.601 7.601 0 0 1-.925-2.383Zm6.723-2.705v.807h1.615v-.807a.808.808 0 0 0-1.614 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 21.92a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478Zm1.737-6.098h.27c.296 0 .537.241.537.538v2.152a.538.538 0 0 1-.538.538h-3.945a.538.538 0 0 1-.538-.538V16.36c0-.297.24-.538.538-.538h.269v-.807c0-.94.764-1.704 1.704-1.704.939 0 1.703.765 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'timeline-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M14.152 7.767V6.63h5.261v.785a7.63 7.63 0 0 1 2.623 1.366 2.1 2.1 0 0 0 .008-.178v-2.63C22.044 4.883 21.16 4 20.07 4H2.973C1.883 4 1 4.884 1 5.973v2.63c0 1.09.884 1.973 1.973 1.973h7.88a7.683 7.683 0 0 1 3.3-2.81Zm-4.385 5.44H2.973c-1.09 0-1.973.883-1.973 1.972v2.63c0 1.09.884 1.974 1.973 1.974h8.514a7.643 7.643 0 0 1-1.497-2.63h-1.1v-1.316h.793a7.718 7.718 0 0 1 .083-2.63Zm6.719.388v.807h1.615v-.807a.808.808 0 0 0-1.614 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 20.5a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478Zm1.737-6.098h.27c.296 0 .537.241.537.538v2.152a.538.538 0 0 1-.538.539h-3.945a.538.538 0 0 1-.538-.539V14.94c0-.297.24-.538.538-.538h.269v-.807c0-.94.764-1.704 1.704-1.704.939 0 1.703.765 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'whiteboard-locked': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M2.17 5.338A2.34 2.34 0 0 1 4.506 3h14.03a2.34 2.34 0 0 1 2.337 2.338v2.18a7.6 7.6 0 0 0-2.338-.799V5.34H4.507v10.52H2.17V5.34Zm7.468 9.596a1.166 1.166 0 0 0-.454.926v1.169H2.169a1.168 1.168 0 1 0 0 2.338h9.388a7.621 7.621 0 0 1-1.92-4.433Zm6.848-1.834v.807h1.615V13.1a.808.808 0 0 0-1.614 0Z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M17.26 20.005a5.74 5.74 0 1 0 0-11.478 5.74 5.74 0 0 0 0 11.478Zm1.737-6.098h.27c.296 0 .537.241.537.538v2.152a.538.538 0 0 1-.538.538h-3.945a.538.538 0 0 1-.538-.538v-2.152c0-.297.24-.538.538-.538h.269V13.1c0-.94.764-1.704 1.704-1.704.939 0 1.703.765 1.703 1.704v.807Z"
          clipRule="evenodd"
        />
      </>
    ),
  },
  'search-sparkles': {
    viewBox: '0 0 24 24',
    paths: (
      <>
        <path
          fill="currentColor"
          d="M12.97 3.42a7.498 7.498 0 0 0-9.964 6.785 7.5 7.5 0 0 0 12.007 6.286l3.938 4.006a1 1 0 0 0 1.425-1.402l-3.94-4.01a7.5 7.5 0 0 0 1.372-2.899l-.302-.113a1.75 1.75 0 0 1-.754-.552 1.84 1.84 0 0 1-1.122.961 5.5 5.5 0 1 1-4.5-7.446l1.39-.642.45-.975Z"
        />
        <path
          fill={themeColors.synced}
          d="M18.036 3.33a.249.249 0 0 0-.161.232c0 .104.064.196.161.233l1.214.455.456 1.214a.249.249 0 0 0 .232.161.249.249 0 0 0 .232-.161l.455-1.214 1.214-.455A.249.249 0 0 0 22 3.563a.249.249 0 0 0-.161-.233l-1.214-.455-.456-1.214a.249.249 0 0 0-.232-.161.249.249 0 0 0-.232.161l-.455 1.214-1.214.455Zm-2.63-.255a.342.342 0 0 0-.623 0L13.65 5.524 11.2 6.656a.343.343 0 0 0 0 .625l2.452 1.133 1.13 2.449a.342.342 0 0 0 .623 0l1.133-2.451 2.45-1.133a.342.342 0 0 0 0-.623l-2.448-1.13-1.133-2.451ZM19.25 9.75l-1.214.456a.249.249 0 0 0-.161.232c0 .103.064.195.161.231l1.214.456.456 1.214a.249.249 0 0 0 .232.161.249.249 0 0 0 .232-.161l.455-1.214 1.214-.456a.249.249 0 0 0 .161-.232.249.249 0 0 0-.161-.231l-1.214-.456-.456-1.214a.249.249 0 0 0-.232-.161.249.249 0 0 0-.232.161L19.25 9.75Z"
        />
      </>
    ),
  },
  lightbulb: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        fill="currentColor"
        d="M15 17.5c.412-1.37 1.268-2.54 2.114-3.704.223-.305.447-.61.662-.92a7.521 7.521 0 0 0 1.349-4.31A7.564 7.564 0 1 0 4 8.563c0 1.603.498 3.09 1.35 4.31.214.31.438.615.66.92.847 1.168 1.703 2.337 2.115 3.708H15ZM11.562 23c1.9 0 3.438-1.538 3.438-3.438v-.687H8.125v.688A3.436 3.436 0 0 0 11.563 23ZM8.126 8.562a.69.69 0 0 1-.688.688.69.69 0 0 1-.687-.688 4.81 4.81 0 0 1 4.813-4.812.69.69 0 0 1 .687.688.69.69 0 0 1-.688.687 3.437 3.437 0 0 0-3.437 3.438Z"
      />
    ),
  },
  'circle-check': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M0.666016 8.00002C0.666016 3.9495 3.94883 0.666687 7.99935 0.666687C12.0499 0.666687 15.3327 3.9495 15.3327 8.00002C15.3327 12.0505 12.0499 15.3334 7.99935 15.3334C3.94883 15.3334 0.666016 12.0505 0.666016 8.00002ZM11.3165 6.73387C11.6288 6.42163 11.6288 5.91174 11.3165 5.5995C11.0043 5.28726 10.4944 5.28726 10.1822 5.5995L7.08268 8.69898L5.81654 7.43283C5.5043 7.12059 4.9944 7.12059 4.68216 7.43283C4.36992 7.74507 4.36992 8.25497 4.68216 8.56721L6.51549 10.4005C6.82773 10.7128 7.33763 10.7128 7.64987 10.4005L11.3165 6.73387Z"
        fill="#198754"
      />
    ),
  },
  brush: {
    viewBox: '0 0 384 512',
    paths: (
      <path
        d="M162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48l0 208 384 0 0-208c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 304l0 16c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-16-384 0zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        fill="currentColor"
      />
    ),
  },
  'brush-slash': {
    viewBox: '0 0 12 13',
    paths: (
      <path
        d="M8.16731 10.1592V11.2295C8.16714 12.114 7.44736 12.8328 6.56282 12.833C5.67813 12.833 4.9585 12.1141 4.95833 11.2295V9.625H3.35481C2.46876 9.625 1.75032 8.90531 1.75032 8.02051V7.21875H5.22688L8.16731 10.1592ZM6.56282 10.8281C6.34236 10.8281 6.16163 11.0091 6.16145 11.2295C6.16163 11.4499 6.34236 11.6299 6.56282 11.6299C6.78314 11.6297 6.96401 11.4498 6.96419 11.2295C6.96401 11.0092 6.78314 10.8283 6.56282 10.8281ZM11.3753 8.02051C11.3753 8.9052 10.6555 9.62482 9.77083 9.625H9.28255L6.8763 7.21875H11.3753V8.02051ZM4.42513 6.41699H1.75032V3.74219L4.42513 6.41699ZM4.15657 1.60449L4.95833 0H5.76106L6.56282 1.60449L7.36458 0H10.1722C10.8362 0.00017601 11.3751 0.538907 11.3753 1.20312V6.41699H6.07454L1.75032 2.09277V1.20312C1.7505 0.538799 2.28908 0 2.95345 0H3.35481L4.15657 1.60449Z"
        fill="currentColor"
      />
    ),
  },
  column: {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M14 4.5L10 4.5L10 19.5L14 19.5L14 4.5ZM16.5 3C16.5 2.44772 16.0523 2 15.5 2L8.5 2C7.94771 2 7.5 2.44772 7.5 3L7.5 21C7.5 21.5523 7.94771 22 8.5 22L15.5 22C16.0523 22 16.5 21.5523 16.5 21L16.5 3Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    ),
  },
  'column-2': {
    viewBox: '0 0 24 24',
    paths: (
      <path
        d="M18.5 2C19.0523 2 19.5 2.44772 19.5 3L19.5 21C19.5 21.5523 19.0523 22 18.5 22H5.5C4.94771 22 4.5 21.5523 4.5 21L4.5 3C4.5 2.44772 4.94772 2 5.5 2L18.5 2ZM13.25 4.5L17 4.5L17 19.5H13.25L13.25 4.5ZM10.75 4.5L7 4.5L7 19.5H10.75L10.75 4.5Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    ),
  },
  'circle-check-outline': {
    viewBox: '0 0 512 512',
    paths: (
      <path
        fill="currentColor"
        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
      />
    ),
  },

  'circle-xmark-outline': {
    viewBox: '0 0 512 512',
    paths: (
      <path
        fill="currentColor"
        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
      />
    ),
  },

  'circle-exclamation-outline': {
    viewBox: '0 0 512 512',
    paths: (
      <path
        fill="currentColor"
        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
      />
    ),
  },

  'circle-outline': {
    viewBox: '0 0 512 512',
    paths: (
      <path
        fill="currentColor"
        d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
      />
    ),
  },

  'calendar-arrow-down-solid-full': {
    viewBox: '0 0 640 640',
    paths: (
      <path
        fill="currentColor"
        d="M224 64C241.7 64 256 78.3 256 96L256 128L384 128L384 96C384 78.3 398.3 64 416 64C433.7 64 448 78.3 448 96L448 128L480 128C515.3 128 544 156.7 544 192L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 192C96 156.7 124.7 128 160 128L192 128L192 96C192 78.3 206.3 64 224 64zM303 449C312.4 458.4 327.6 458.4 336.9 449L408.9 377C418.3 367.6 418.3 352.4 408.9 343.1C399.5 333.8 384.3 333.7 375 343.1L344 374.1L344 272C344 258.7 333.3 248 320 248C306.7 248 296 258.7 296 272L296 374.1L265 343.1C255.6 333.7 240.4 333.7 231.1 343.1C221.8 352.5 221.7 367.7 231.1 377L303.1 449z"
      />
    ),
  },
};

type ODSIconName = keyof typeof ODSIcons;
const ODSIconNames: ODSIconName[] = Object.keys(ODSIcons) as ODSIconName[];

export type { ODSIcon, ODSIconName };
export { ODSIconNames };
export const ODSIconMap: Record<ODSIconName, ODSIcon> = ODSIcons;
export default ODSIcons;
